(function() {
    'use strict';

    angular
        .module('adValoremApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ui.validate'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'},
            'getAll': {
                method: 'GET',
                isArray: true,
                url: 'api/users?size=1000'
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' ];

    function AuthServerProvider ($http, $localStorage ) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {

            
            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            $state.go('jhi-login');
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ZoneDialogController', ZoneDialogController);

    ZoneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Zone', 'Country'];

    function ZoneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Zone, Country) {
        var vm = this;

        vm.zone = entity;
        vm.clear = clear;
        vm.save = save;
        vm.countries = Country.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.zone.id !== null) {
                Zone.update(vm.zone, onSaveSuccess, onSaveError);
            } else {
                Zone.save(vm.zone, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('adValoremApp:zoneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ZoneDetailController', ZoneDetailController);

    ZoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Zone', 'Country'];

    function ZoneDetailController($scope, $rootScope, $stateParams, previousState, entity, Zone, Country) {
        var vm = this;

        vm.zone = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('adValoremApp:zoneUpdate', function(event, result) {
            vm.zone = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ZoneDeleteController',ZoneDeleteController);

    ZoneDeleteController.$inject = ['$uibModalInstance', 'entity', 'Zone'];

    function ZoneDeleteController($uibModalInstance, entity, Zone) {
        var vm = this;

        vm.zone = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Zone.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('zone', {
            parent: 'entity',
            url: '/zone?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.zone.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/zone/zones.html',
                    controller: 'ZoneController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('zone');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('zone-detail', {
            parent: 'zone',
            url: '/zone/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.zone.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/zone/zone-detail.html',
                    controller: 'ZoneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('zone');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Zone', function($stateParams, Zone) {
                    return Zone.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'zone',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('zone-detail.edit', {
            parent: 'zone-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zone/zone-dialog.html',
                    controller: 'ZoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Zone', function(Zone) {
                            return Zone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('zone.new', {
            parent: 'zone',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zone/zone-dialog.html',
                    controller: 'ZoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('zone', null, { reload: 'zone' });
                }, function() {
                    $state.go('zone');
                });
            }]
        })
        .state('zone.edit', {
            parent: 'zone',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zone/zone-dialog.html',
                    controller: 'ZoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Zone', function(Zone) {
                            return Zone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('zone', null, { reload: 'zone' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('zone.delete', {
            parent: 'zone',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zone/zone-delete-dialog.html',
                    controller: 'ZoneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Zone', function(Zone) {
                            return Zone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('zone', null, { reload: 'zone' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('adValoremApp')
        .factory('Zone', Zone);

    Zone.$inject = ['$resource'];

    function Zone ($resource) {
        var resourceUrl =  'api/zones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getZone1Name': {
                method: 'GET',
                url: 'api/zones/zone1Name'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('ZoneSearch', ZoneSearch);

    ZoneSearch.$inject = ['$resource'];

    function ZoneSearch($resource) {
        var resourceUrl =  'api/_search/zones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ZoneController', ZoneController);

    ZoneController.$inject = ['$state', 'Zone', 'ZoneSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ZoneController($state, Zone, ZoneSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ZoneSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Zone.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.zones = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('TransportTypeDialogController', TransportTypeDialogController);

    TransportTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TransportType'];

    function TransportTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TransportType) {
        var vm = this;

        vm.transportType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.transportType.id !== null) {
                TransportType.update(vm.transportType, onSaveSuccess, onSaveError);
            } else {
                TransportType.save(vm.transportType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('adValoremApp:transportTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('TransportTypeDetailController', TransportTypeDetailController);

    TransportTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TransportType'];

    function TransportTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, TransportType) {
        var vm = this;

        vm.transportType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('adValoremApp:transportTypeUpdate', function(event, result) {
            vm.transportType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('TransportTypeDeleteController',TransportTypeDeleteController);

    TransportTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'TransportType'];

    function TransportTypeDeleteController($uibModalInstance, entity, TransportType) {
        var vm = this;

        vm.transportType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TransportType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('transport-type', {
            parent: 'entity',
            url: '/transport-type?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.transportType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/transport-type/transport-types.html',
                    controller: 'TransportTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('transportType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('transport-type-detail', {
            parent: 'transport-type',
            url: '/transport-type/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.transportType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/transport-type/transport-type-detail.html',
                    controller: 'TransportTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('transportType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TransportType', function($stateParams, TransportType) {
                    return TransportType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'transport-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('transport-type-detail.edit', {
            parent: 'transport-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transport-type/transport-type-dialog.html',
                    controller: 'TransportTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TransportType', function(TransportType) {
                            return TransportType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('transport-type.new', {
            parent: 'transport-type',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transport-type/transport-type-dialog.html',
                    controller: 'TransportTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('transport-type', null, { reload: 'transport-type' });
                }, function() {
                    $state.go('transport-type');
                });
            }]
        })
        .state('transport-type.edit', {
            parent: 'transport-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transport-type/transport-type-dialog.html',
                    controller: 'TransportTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TransportType', function(TransportType) {
                            return TransportType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('transport-type', null, { reload: 'transport-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('transport-type.delete', {
            parent: 'transport-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transport-type/transport-type-delete-dialog.html',
                    controller: 'TransportTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TransportType', function(TransportType) {
                            return TransportType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('transport-type', null, { reload: 'transport-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('adValoremApp')
        .factory('TransportType', TransportType);

    TransportType.$inject = ['$resource'];

    function TransportType ($resource) {
        var resourceUrl =  'api/transport-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getTransportTypeTerrestreName': {
                method: 'GET',
                url: 'api/transport-types/terrestreName'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('TransportTypeSearch', TransportTypeSearch);

    TransportTypeSearch.$inject = ['$resource'];

    function TransportTypeSearch($resource) {
        var resourceUrl =  'api/_search/transport-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('TransportTypeController', TransportTypeController);

    TransportTypeController.$inject = ['$state', 'TransportType', 'TransportTypeSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TransportTypeController($state, TransportType, TransportTypeSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                TransportTypeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                TransportType.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.transportTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ObjectTypeDialogController', ObjectTypeDialogController);

    ObjectTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ObjectType'];

    function ObjectTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ObjectType) {
        var vm = this;

        vm.objectType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.objectType.id !== null) {
                ObjectType.update(vm.objectType, onSaveSuccess, onSaveError);
            } else {
                ObjectType.save(vm.objectType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('adValoremApp:objectTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ObjectTypeDetailController', ObjectTypeDetailController);

    ObjectTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ObjectType'];

    function ObjectTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, ObjectType) {
        var vm = this;

        vm.objectType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('adValoremApp:objectTypeUpdate', function(event, result) {
            vm.objectType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ObjectTypeDeleteController',ObjectTypeDeleteController);

    ObjectTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'ObjectType'];

    function ObjectTypeDeleteController($uibModalInstance, entity, ObjectType) {
        var vm = this;

        vm.objectType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ObjectType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('object-type', {
            parent: 'entity',
            url: '/object-type?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.objectType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/object-type/object-types.html',
                    controller: 'ObjectTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('objectType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('object-type-detail', {
            parent: 'object-type',
            url: '/object-type/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.objectType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/object-type/object-type-detail.html',
                    controller: 'ObjectTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('objectType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ObjectType', function($stateParams, ObjectType) {
                    return ObjectType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'object-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('object-type-detail.edit', {
            parent: 'object-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/object-type/object-type-dialog.html',
                    controller: 'ObjectTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ObjectType', function(ObjectType) {
                            return ObjectType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('object-type.new', {
            parent: 'object-type',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/object-type/object-type-dialog.html',
                    controller: 'ObjectTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('object-type', null, { reload: 'object-type' });
                }, function() {
                    $state.go('object-type');
                });
            }]
        })
        .state('object-type.edit', {
            parent: 'object-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/object-type/object-type-dialog.html',
                    controller: 'ObjectTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ObjectType', function(ObjectType) {
                            return ObjectType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('object-type', null, { reload: 'object-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('object-type.delete', {
            parent: 'object-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/object-type/object-type-delete-dialog.html',
                    controller: 'ObjectTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ObjectType', function(ObjectType) {
                            return ObjectType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('object-type', null, { reload: 'object-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('adValoremApp')
        .factory('ObjectType', ObjectType);

    ObjectType.$inject = ['$resource'];

    function ObjectType ($resource) {
        var resourceUrl =  'api/object-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('ObjectTypeSearch', ObjectTypeSearch);

    ObjectTypeSearch.$inject = ['$resource'];

    function ObjectTypeSearch($resource) {
        var resourceUrl =  'api/_search/object-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ObjectTypeController', ObjectTypeController);

    ObjectTypeController.$inject = ['$state', 'ObjectType', 'ObjectTypeSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ObjectTypeController($state, ObjectType, ObjectTypeSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ObjectTypeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ObjectType.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.objectTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('GuaranteeTypeDialogController', GuaranteeTypeDialogController);

    GuaranteeTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GuaranteeType'];

    function GuaranteeTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GuaranteeType) {
        var vm = this;

        vm.guaranteeType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.guaranteeType.id !== null) {
                GuaranteeType.update(vm.guaranteeType, onSaveSuccess, onSaveError);
            } else {
                GuaranteeType.save(vm.guaranteeType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('adValoremApp:guaranteeTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('GuaranteeTypeDetailController', GuaranteeTypeDetailController);

    GuaranteeTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GuaranteeType'];

    function GuaranteeTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, GuaranteeType) {
        var vm = this;

        vm.guaranteeType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('adValoremApp:guaranteeTypeUpdate', function(event, result) {
            vm.guaranteeType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('GuaranteeTypeDeleteController',GuaranteeTypeDeleteController);

    GuaranteeTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'GuaranteeType'];

    function GuaranteeTypeDeleteController($uibModalInstance, entity, GuaranteeType) {
        var vm = this;

        vm.guaranteeType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GuaranteeType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('guarantee-type', {
            parent: 'entity',
            url: '/guarantee-type?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.guaranteeType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/guarantee-type/guarantee-types.html',
                    controller: 'GuaranteeTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('guaranteeType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('guarantee-type-detail', {
            parent: 'guarantee-type',
            url: '/guarantee-type/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.guaranteeType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/guarantee-type/guarantee-type-detail.html',
                    controller: 'GuaranteeTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('guaranteeType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GuaranteeType', function($stateParams, GuaranteeType) {
                    return GuaranteeType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'guarantee-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('guarantee-type-detail.edit', {
            parent: 'guarantee-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/guarantee-type/guarantee-type-dialog.html',
                    controller: 'GuaranteeTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GuaranteeType', function(GuaranteeType) {
                            return GuaranteeType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('guarantee-type.new', {
            parent: 'guarantee-type',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/guarantee-type/guarantee-type-dialog.html',
                    controller: 'GuaranteeTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('guarantee-type', null, { reload: 'guarantee-type' });
                }, function() {
                    $state.go('guarantee-type');
                });
            }]
        })
        .state('guarantee-type.edit', {
            parent: 'guarantee-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/guarantee-type/guarantee-type-dialog.html',
                    controller: 'GuaranteeTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GuaranteeType', function(GuaranteeType) {
                            return GuaranteeType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('guarantee-type', null, { reload: 'guarantee-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('guarantee-type.delete', {
            parent: 'guarantee-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/guarantee-type/guarantee-type-delete-dialog.html',
                    controller: 'GuaranteeTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GuaranteeType', function(GuaranteeType) {
                            return GuaranteeType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('guarantee-type', null, { reload: 'guarantee-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('adValoremApp')
        .factory('GuaranteeType', GuaranteeType);

    GuaranteeType.$inject = ['$resource'];

    function GuaranteeType ($resource) {
        var resourceUrl =  'api/guarantee-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('GuaranteeTypeSearch', GuaranteeTypeSearch);

    GuaranteeTypeSearch.$inject = ['$resource'];

    function GuaranteeTypeSearch($resource) {
        var resourceUrl =  'api/_search/guarantee-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('GuaranteeTypeController', GuaranteeTypeController);

    GuaranteeTypeController.$inject = ['$state', 'GuaranteeType', 'GuaranteeTypeSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function GuaranteeTypeController($state, GuaranteeType, GuaranteeTypeSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                GuaranteeTypeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                GuaranteeType.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.guaranteeTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('GuaranteeStatusDialogController', GuaranteeStatusDialogController);

    GuaranteeStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GuaranteeStatus'];

    function GuaranteeStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GuaranteeStatus) {
        var vm = this;

        vm.guaranteeStatus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.guaranteeStatus.id !== null) {
                GuaranteeStatus.update(vm.guaranteeStatus, onSaveSuccess, onSaveError);
            } else {
                GuaranteeStatus.save(vm.guaranteeStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('adValoremApp:guaranteeStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('GuaranteeStatusDetailController', GuaranteeStatusDetailController);

    GuaranteeStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GuaranteeStatus'];

    function GuaranteeStatusDetailController($scope, $rootScope, $stateParams, previousState, entity, GuaranteeStatus) {
        var vm = this;

        vm.guaranteeStatus = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('adValoremApp:guaranteeStatusUpdate', function(event, result) {
            vm.guaranteeStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('GuaranteeStatusDeleteController',GuaranteeStatusDeleteController);

    GuaranteeStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'GuaranteeStatus'];

    function GuaranteeStatusDeleteController($uibModalInstance, entity, GuaranteeStatus) {
        var vm = this;

        vm.guaranteeStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GuaranteeStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('guarantee-status', {
            parent: 'entity',
            url: '/guarantee-status?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.guaranteeStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/guarantee-status/guarantee-statuses.html',
                    controller: 'GuaranteeStatusController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('guaranteeStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('guarantee-status-detail', {
            parent: 'guarantee-status',
            url: '/guarantee-status/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.guaranteeStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/guarantee-status/guarantee-status-detail.html',
                    controller: 'GuaranteeStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('guaranteeStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GuaranteeStatus', function($stateParams, GuaranteeStatus) {
                    return GuaranteeStatus.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'guarantee-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('guarantee-status-detail.edit', {
            parent: 'guarantee-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/guarantee-status/guarantee-status-dialog.html',
                    controller: 'GuaranteeStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GuaranteeStatus', function(GuaranteeStatus) {
                            return GuaranteeStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('guarantee-status.new', {
            parent: 'guarantee-status',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/guarantee-status/guarantee-status-dialog.html',
                    controller: 'GuaranteeStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('guarantee-status', null, { reload: 'guarantee-status' });
                }, function() {
                    $state.go('guarantee-status');
                });
            }]
        })
        .state('guarantee-status.edit', {
            parent: 'guarantee-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/guarantee-status/guarantee-status-dialog.html',
                    controller: 'GuaranteeStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GuaranteeStatus', function(GuaranteeStatus) {
                            return GuaranteeStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('guarantee-status', null, { reload: 'guarantee-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('guarantee-status.delete', {
            parent: 'guarantee-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/guarantee-status/guarantee-status-delete-dialog.html',
                    controller: 'GuaranteeStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GuaranteeStatus', function(GuaranteeStatus) {
                            return GuaranteeStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('guarantee-status', null, { reload: 'guarantee-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('adValoremApp')
        .factory('GuaranteeStatus', GuaranteeStatus);

    GuaranteeStatus.$inject = ['$resource'];

    function GuaranteeStatus ($resource) {
        var resourceUrl =  'api/guarantee-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('GuaranteeStatusSearch', GuaranteeStatusSearch);

    GuaranteeStatusSearch.$inject = ['$resource'];

    function GuaranteeStatusSearch($resource) {
        var resourceUrl =  'api/_search/guarantee-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('GuaranteeStatusController', GuaranteeStatusController);

    GuaranteeStatusController.$inject = ['$state', 'GuaranteeStatus', 'GuaranteeStatusSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function GuaranteeStatusController($state, GuaranteeStatus, GuaranteeStatusSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                GuaranteeStatusSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                GuaranteeStatus.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.guaranteeStatuses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('GuaranteeResModalController', GuaranteeResModalController);

    GuaranteeResModalController.$inject = ['$uibModalInstance', 'items', '$filter'];

    function GuaranteeResModalController ($uibModalInstance, items, $filter) {
        var vm = this;

        vm.guarantee = items;
        vm.closeModalRes = closeModalRes;

        if (vm.guarantee.isDevis != null && vm.guarantee.isDevis) {
            vm.headerModalRes = $filter('translate')('adValoremApp.guarantee.modalRes.headerDevis');
        } else {
            vm.headerModalRes = $filter('translate')('adValoremApp.guarantee.modalRes.headerGuarantee');
        }

        function closeModalRes() {
            $uibModalInstance.close('Closing modal');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('GuaranteeNoDialogController', GuaranteeNoDialogController);

    GuaranteeNoDialogController.$inject = ['$timeout', '$scope', '$state', '$filter', '$uibModal', 'entity', 'Guarantee', 'GuaranteeType', 'TransportType', 'ObjectType', 'Country', 'AdValoremDocument', 'GuaranteeStatus', 'Principal', 'Facility', 'Contract', 'Zone'];

    function GuaranteeNoDialogController ($timeout, $scope, $state, $filter, $uibModal, entity, Guarantee, GuaranteeType, TransportType, ObjectType, Country, AdValoremDocument, GuaranteeStatus, Principal, Facility, Contract, Zone) {
        var vm = this;

        vm.guarantee = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.guaranteetypes = GuaranteeType.query();
        vm.transporttypes = TransportType.query();
        vm.objecttypes = ObjectType.query();
        vm.countries = Country.getAll();
        vm.guaranteestatuses = GuaranteeStatus.query();
        vm.guarantee.vehiculeValue = 0;
        vm.modalResInstance = null;
        vm.zone1Name = {};
        vm.transportTypeTerrestreName = {};
        vm.facilities = [];
        vm.contract = {};
        vm.validateArtObject = validateArtObject;
        vm.validateAccessibleByRoad = validateAccessibleByRoad;
        vm.validateAtLeastOneCountryIsInZone1 = validateAtLeastOneCountryIsInZone1;
        vm.validateIsInfToMaxGlobalValue = validateIsInfToMaxGlobalValue;
        vm.validateIsInfToMaxObjectValue = validateIsInfToMaxObjectValue;
        vm.validateIfNbossMustBeZero = validateIfNbossMustBeZero;
        vm.validateIfVtossMustBeZero = validateIfVtossMustBeZero;
        vm.validateEffectiveDate = validateEffectiveDate;
        vm.updateMinVtossValue = updateMinVtossValue;

        // Set today's date at midnight
        vm.today = new Date();
        vm.today.setHours(0);
        vm.today.setMinutes(0);
        vm.today.setSeconds(0);
        vm.today.setMilliseconds(0);

        // Min possible value of vtoss
        vm.minVtossValue = 0;

        vm.zone1Name = Zone.getZone1Name();
        vm.transportTypeTerrestreName = TransportType.getTransportTypeTerrestreName();

        Principal.identity().then(function(account) {
            vm.guarantee.userLogin = account.login;
            getFacilityOfUser(encodeURIComponent(vm.guarantee.userLogin));
            getContractOfUser(encodeURIComponent(vm.guarantee.userLogin));
        });

        // Titre du formulaire selon devis ou demande de garantie
        if (vm.guarantee.isDevis) {
            vm.title = $filter('translate')('adValoremApp.guarantee.devisPageTitle');
            vm.btnSubmitLabel = $filter('translate')('adValoremApp.guarantee.submitDevis');
        } else {
            vm.title = $filter('translate')('adValoremApp.guarantee.home.createLabel');
            vm.btnSubmitLabel = $filter('translate')('adValoremApp.guarantee.submit');
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function getFacilityOfUser(userLogin) {
            vm.facilities = Facility.getByUserLogin({userLogin: userLogin});
        }

        function getContractOfUser(userLogin) {
            vm.contract = Contract.getByUserLogin({userLogin: userLogin});
        }

        function clear (){
            $state.go('home', null, { relative: false });
        }

        function save () {
            vm.isSaving = true;
            Guarantee.save(vm.guarantee, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('adValoremApp:guaranteeUpdate', result);
            openModalRes(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.effectiveDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function openModalRes (resGuarantee) {
            vm.modalResInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'res-guarantee-modal-title',
                ariaDescribedBy: 'res-guarantee-modal-body',
                templateUrl: 'resGuaranteeModal.html',
                controller: 'GuaranteeResModalController',
                controllerAs: 'vm',
                size: 'lg',
                windowClass: 'guarantee-modal-res',
                //appendTo: parentElem,
                resolve: {
                    items: function () {
                        return resGuarantee;
                    }
                }
            });
        }

        function validateArtObject (value) {
            return value != 'true';
        }

        function validateAccessibleByRoad (value) {
            var isAccessible = true;
            if (vm.guarantee.transportType != null && value != null) {
                if(vm.guarantee.transportType.name == vm.transportTypeTerrestreName.transportTypeTerrestre) {
                    isAccessible = (value.zone.name == vm.zone1Name.zone1Name);
                }
            }
            return isAccessible;
        }

        function validateAtLeastOneCountryIsInZone1 (value, otherCountry) {
            var atLeastOneCountryIsInZone1 = true;
            if (value != null && otherCountry != null) {
                atLeastOneCountryIsInZone1 = (value.zone.name == vm.zone1Name.zone1Name) || (otherCountry.zone.name == vm.zone1Name.zone1Name);
            }
            return atLeastOneCountryIsInZone1;
        }

        function validateIsInfToMaxGlobalValue (value) {
            var isInfToMaxGlobalValue = true;
            if (value != null) {
                isInfToMaxGlobalValue = (value <= vm.contract.maxGlobalValue);
            }
            return isInfToMaxGlobalValue;
        }

        function validateIsInfToMaxObjectValue (value) {
            var isInfToMaxObjectValue = true;
            if (value != null && vm.guarantee.nboss != null && vm.guarantee.nboss > 0) {
                isInfToMaxObjectValue = (value / vm.guarantee.nboss) <= vm.contract.maxObjectValue;
            }
            return isInfToMaxObjectValue;
        }

        function validateIfNbossMustBeZero (value) {
            var nbossIsValid = true;
            if (value != null && vm.guarantee.vtoss != null){
                if (value > 0) {
                    nbossIsValid = vm.guarantee.vtoss > 0;
                }
            }
            return nbossIsValid;
        }

        function validateIfVtossMustBeZero (value) {
            var vtossIsValid = true;
            if (value != null && vm.guarantee.nboss != null){
                if (value > 0) {
                    vtossIsValid = vm.guarantee.nboss > 0;
                }
            }
            return vtossIsValid;
        }

        function validateEffectiveDate (value) {
            var isAtLeastToday = true;
            if (value != null) {
                isAtLeastToday = (value >= vm.today);
            }
            return isAtLeastToday;
        }

        function updateMinVtossValue () {
            if (vm.guarantee.nboss != null) {
                vm.minVtossValue = vm.guarantee.nboss * vm.contract.minObjectValue;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('GuaranteeDialogController', GuaranteeDialogController);

    GuaranteeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Guarantee', 'GuaranteeType', 'TransportType', 'ObjectType', 'Country', 'AdValoremDocument', 'GuaranteeStatus', 'Client', 'Facility'];

    function GuaranteeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Guarantee, GuaranteeType, TransportType, ObjectType, Country, AdValoremDocument, GuaranteeStatus, Client, Facility) {
        var vm = this;

        vm.guarantee = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.guaranteetypes = GuaranteeType.query();
        vm.transporttypes = TransportType.query();
        vm.objecttypes = ObjectType.query();
        vm.countries = Country.getAll();
        vm.guaranteestatuses = GuaranteeStatus.query();
        vm.clients = Client.getAll();
        vm.facilities = Facility.getAll();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            Guarantee.update(vm.guarantee, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('adValoremApp:guaranteeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.effectiveDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('GuaranteeDetailController', GuaranteeDetailController);

    GuaranteeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Guarantee', 'GuaranteeType', 'TransportType', 'ObjectType', 'Country', 'AdValoremDocument', 'GuaranteeStatus', 'Client', 'Facility'];

    function GuaranteeDetailController($scope, $rootScope, $stateParams, previousState, entity, Guarantee, GuaranteeType, TransportType, ObjectType, Country, AdValoremDocument, GuaranteeStatus, Client, Facility) {
        var vm = this;

        vm.guarantee = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('adValoremApp:guaranteeUpdate', function(event, result) {
            vm.guarantee = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('GuaranteeCancelController',GuaranteeCancelController);

    GuaranteeCancelController.$inject = ['$uibModalInstance', 'entity', 'Guarantee'];

    function GuaranteeCancelController($uibModalInstance, entity, Guarantee) {
        var vm = this;

        vm.guarantee = entity;
        vm.clear = clear;
        vm.confirmCancel = confirmCancel;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmCancel (id) {
            Guarantee.cancel({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('guarantee', {
            parent: 'entity',
            url: '/guarantee?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.guarantee.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/guarantee/guarantees.html',
                    controller: 'GuaranteeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('guarantee');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('guarantee-detail', {
            parent: 'guarantee',
            url: '/guarantee/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.guarantee.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/guarantee/guarantee-detail.html',
                    controller: 'GuaranteeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('guarantee');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Guarantee', function($stateParams, Guarantee) {
                    return Guarantee.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'guarantee',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('guarantee-detail.edit', {
            parent: 'guarantee-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/guarantee/guarantee-dialog.html',
                    controller: 'GuaranteeNoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Guarantee', function(Guarantee) {
                            return Guarantee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('guarantee.new', {
            parent: 'guarantee',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/guarantee/guarantee-dialog.html',
                    controller: 'GuaranteeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                effectiveDate: null,
                                policyholderName: null,
                                departureSite: null,
                                arrivalSite: null,
                                globalGuarantedValue: null,
                                vehiculeValue: null,
                                vtoss: null,
                                nboss: null,
                                additionnalBonusObjectValue: null,
                                additionnalBonusGlobalValue: null,
                                bonusVehiculeValue: null,
                                totalBonus: null,
                                tauxRC: null,
                                tauxDommage: null,
                                tauxValeurVehicule: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('guarantee', null, { reload: 'guarantee' });
                }, function() {
                    $state.go('guarantee');
                });
            }]
        })
        .state('guarantee.new.nodialog', {
            parent: 'guarantee',
            url: '/nodialog/new',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/guarantee/guarantee-nodialog.html',
                    controller: 'GuaranteeNoDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('guarantee');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: function($stateParams, Guarantee) {
                    return {
                        effectiveDate: null,
                        policyholderName: null,
                        departureSite: null,
                        arrivalSite: null,
                        globalGuarantedValue: null,
                        additionnalBonusObjectValue: null,
                        additionnalBonusGlobalValue: null,
                        bonusVehiculeValue: null,
                        id: null,
                        artObject: null,
                        transportedVehicle: null,
                        isDevis: false
                    }
                }
            }
        })
        .state('guarantee.new.devis', {
            parent: 'guarantee',
            url: '/devis/new',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/guarantee/guarantee-nodialog.html',
                    controller: 'GuaranteeNoDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('guarantee');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: function($stateParams, Guarantee) {
                    return {
                        effectiveDate: null,
                        policyholderName: null,
                        departureSite: null,
                        arrivalSite: null,
                        globalGuarantedValue: null,
                        additionnalBonusObjectValue: null,
                        additionnalBonusGlobalValue: null,
                        bonusVehiculeValue: null,
                        id: null,
                        artObject: null,
                        transportedVehicle: null,
                        isDevis: true
                    }
                }
            }
        })
        .state('guarantee.edit', {
            parent: 'guarantee',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/guarantee/guarantee-dialog.html',
                    controller: 'GuaranteeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Guarantee', function(Guarantee) {
                            return Guarantee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('guarantee', null, { reload: 'guarantee' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('guarantee.cancel', {
            parent: 'guarantee',
            url: '/{id}/cancel',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/guarantee/guarantee-cancel-dialog.html',
                    controller: 'GuaranteeCancelController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Guarantee', function(Guarantee) {
                            return Guarantee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('guarantee', null, { reload: 'guarantee' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('adValoremApp')
        .factory('Guarantee', Guarantee);

    Guarantee.$inject = ['$resource', 'DateUtils'];

    function Guarantee ($resource, DateUtils) {
        var resourceUrl =  'api/guarantees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveDate = DateUtils.convertLocalDateFromServer(data.effectiveDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.effectiveDate = DateUtils.convertLocalDateToServer(copy.effectiveDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.effectiveDate = DateUtils.convertLocalDateToServer(copy.effectiveDate);
                    return angular.toJson(copy);
                }
            },
            'cancel': {
                method: 'POST',
                params: {id: '@id'},
                url: 'api/guarantees/cancel/:id'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('GuaranteeSearch', GuaranteeSearch);

    GuaranteeSearch.$inject = ['$resource'];

    function GuaranteeSearch($resource) {
        var resourceUrl =  'api/_search/guarantees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('GuaranteeController', GuaranteeController);

    GuaranteeController.$inject = ['$state', 'Guarantee', 'GuaranteeSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function GuaranteeController($state, Guarantee, GuaranteeSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                GuaranteeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Guarantee.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.guarantees = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('FacilityDialogController', FacilityDialogController);

    FacilityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Facility', 'Guarantee', 'Client'];

    function FacilityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Facility, Guarantee, Client) {
        var vm = this;

        vm.facility = entity;
        vm.clear = clear;
        vm.save = save;
        vm.guarantees = Guarantee.query();
        vm.clients = Client.getAll();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.facility.id !== null) {
                Facility.update(vm.facility, onSaveSuccess, onSaveError);
            } else {
                Facility.save(vm.facility, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('adValoremApp:facilityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('FacilityDetailController', FacilityDetailController);

    FacilityDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Facility', 'Guarantee', 'Client'];

    function FacilityDetailController($scope, $rootScope, $stateParams, previousState, entity, Facility, Guarantee, Client) {
        var vm = this;

        vm.facility = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('adValoremApp:facilityUpdate', function(event, result) {
            vm.facility = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('FacilityDeleteController',FacilityDeleteController);

    FacilityDeleteController.$inject = ['$uibModalInstance', 'entity', 'Facility'];

    function FacilityDeleteController($uibModalInstance, entity, Facility) {
        var vm = this;

        vm.facility = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Facility.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('facility', {
            parent: 'entity',
            url: '/facility?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.facility.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/facility/facilities.html',
                    controller: 'FacilityController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('facility');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('facility-detail', {
            parent: 'facility',
            url: '/facility/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.facility.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/facility/facility-detail.html',
                    controller: 'FacilityDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('facility');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Facility', function($stateParams, Facility) {
                    return Facility.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'facility',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('facility-detail.edit', {
            parent: 'facility-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/facility/facility-dialog.html',
                    controller: 'FacilityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Facility', function(Facility) {
                            return Facility.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('facility.new', {
            parent: 'facility',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/facility/facility-dialog.html',
                    controller: 'FacilityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                email: null,
                                address1: null,
                                address2: null,
                                address3: null,
                                postalCode: null,
                                city: null,
                                phoneNumber: null,
                                faxNumber: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('facility', null, { reload: 'facility' });
                }, function() {
                    $state.go('facility');
                });
            }]
        })
        .state('facility.edit', {
            parent: 'facility',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/facility/facility-dialog.html',
                    controller: 'FacilityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Facility', function(Facility) {
                            return Facility.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('facility', null, { reload: 'facility' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('facility.delete', {
            parent: 'facility',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/facility/facility-delete-dialog.html',
                    controller: 'FacilityDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Facility', function(Facility) {
                            return Facility.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('facility', null, { reload: 'facility' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('adValoremApp')
        .factory('Facility', Facility);

    Facility.$inject = ['$resource'];

    function Facility ($resource) {
        var resourceUrl =  'api/facilities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getByUserLogin': {
                method: 'GET',
                isArray: true,
                url: 'api/facilities/login/:userLogin'
            },
            'getAll': {
                method: 'GET',
                isArray: true,
                url: 'api/facilities?size=1000'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('FacilitySearch', FacilitySearch);

    FacilitySearch.$inject = ['$resource'];

    function FacilitySearch($resource) {
        var resourceUrl =  'api/_search/facilities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('FacilityController', FacilityController);

    FacilityController.$inject = ['$state', 'Facility', 'FacilitySearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function FacilityController($state, Facility, FacilitySearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                FacilitySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Facility.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.facilities = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('DommageRateDialogController', DommageRateDialogController);

    DommageRateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DommageRate', 'TransportType', 'Zone', 'Client'];

    function DommageRateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DommageRate, TransportType, Zone, Client) {
        var vm = this;

        vm.dommageRate = entity;
        vm.clear = clear;
        vm.save = save;
        vm.transporttypes = TransportType.query();
        vm.zones = Zone.query();
        vm.clients = Client.getAll();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dommageRate.id !== null) {
                DommageRate.update(vm.dommageRate, onSaveSuccess, onSaveError);
            } else {
                DommageRate.save(vm.dommageRate, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('adValoremApp:dommageRateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('DommageRateDetailController', DommageRateDetailController);

    DommageRateDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DommageRate', 'TransportType', 'Zone', 'Client'];

    function DommageRateDetailController($scope, $rootScope, $stateParams, previousState, entity, DommageRate, TransportType, Zone, Client) {
        var vm = this;

        vm.dommageRate = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('adValoremApp:dommageRateUpdate', function(event, result) {
            vm.dommageRate = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('DommageRateDeleteController',DommageRateDeleteController);

    DommageRateDeleteController.$inject = ['$uibModalInstance', 'entity', 'DommageRate'];

    function DommageRateDeleteController($uibModalInstance, entity, DommageRate) {
        var vm = this;

        vm.dommageRate = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DommageRate.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dommage-rate', {
            parent: 'entity',
            url: '/dommage-rate?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.dommageRate.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dommage-rate/dommage-rates.html',
                    controller: 'DommageRateController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dommageRate');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dommage-rate-detail', {
            parent: 'dommage-rate',
            url: '/dommage-rate/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.dommageRate.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dommage-rate/dommage-rate-detail.html',
                    controller: 'DommageRateDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dommageRate');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DommageRate', function($stateParams, DommageRate) {
                    return DommageRate.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dommage-rate',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dommage-rate-detail.edit', {
            parent: 'dommage-rate-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dommage-rate/dommage-rate-dialog.html',
                    controller: 'DommageRateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DommageRate', function(DommageRate) {
                            return DommageRate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dommage-rate.new', {
            parent: 'dommage-rate',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dommage-rate/dommage-rate-dialog.html',
                    controller: 'DommageRateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                rate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dommage-rate', null, { reload: 'dommage-rate' });
                }, function() {
                    $state.go('dommage-rate');
                });
            }]
        })
        .state('dommage-rate.edit', {
            parent: 'dommage-rate',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dommage-rate/dommage-rate-dialog.html',
                    controller: 'DommageRateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DommageRate', function(DommageRate) {
                            return DommageRate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dommage-rate', null, { reload: 'dommage-rate' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dommage-rate.delete', {
            parent: 'dommage-rate',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dommage-rate/dommage-rate-delete-dialog.html',
                    controller: 'DommageRateDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DommageRate', function(DommageRate) {
                            return DommageRate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dommage-rate', null, { reload: 'dommage-rate' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('adValoremApp')
        .factory('DommageRate', DommageRate);

    DommageRate.$inject = ['$resource'];

    function DommageRate ($resource) {
        var resourceUrl =  'api/dommage-rates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('DommageRateSearch', DommageRateSearch);

    DommageRateSearch.$inject = ['$resource'];

    function DommageRateSearch($resource) {
        var resourceUrl =  'api/_search/dommage-rates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('DommageRateController', DommageRateController);

    DommageRateController.$inject = ['$state', 'DommageRate', 'DommageRateSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function DommageRateController($state, DommageRate, DommageRateSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                DommageRateSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                DommageRate.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.dommageRates = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('CountryDialogController', CountryDialogController);

    CountryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Country', 'Zone'];

    function CountryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Country, Zone) {
        var vm = this;

        vm.country = entity;
        vm.clear = clear;
        vm.save = save;
        vm.zones = Zone.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.country.id !== null) {
                Country.update(vm.country, onSaveSuccess, onSaveError);
            } else {
                Country.save(vm.country, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('adValoremApp:countryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('CountryDetailController', CountryDetailController);

    CountryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Country', 'Zone'];

    function CountryDetailController($scope, $rootScope, $stateParams, previousState, entity, Country, Zone) {
        var vm = this;

        vm.country = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('adValoremApp:countryUpdate', function(event, result) {
            vm.country = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('CountryDeleteController',CountryDeleteController);

    CountryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Country'];

    function CountryDeleteController($uibModalInstance, entity, Country) {
        var vm = this;

        vm.country = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Country.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('country', {
            parent: 'entity',
            url: '/country?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.country.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country/countries.html',
                    controller: 'CountryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('country');
                    $translatePartialLoader.addPart('countryStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('country-detail', {
            parent: 'country',
            url: '/country/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.country.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country/country-detail.html',
                    controller: 'CountryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('country');
                    $translatePartialLoader.addPart('countryStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Country', function($stateParams, Country) {
                    return Country.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'country',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('country-detail.edit', {
            parent: 'country-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country.new', {
            parent: 'country',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                codeIso2: null,
                                codeIso3: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: 'country' });
                }, function() {
                    $state.go('country');
                });
            }]
        })
        .state('country.edit', {
            parent: 'country',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: 'country' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country.delete', {
            parent: 'country',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-delete-dialog.html',
                    controller: 'CountryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: 'country' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('adValoremApp')
        .factory('Country', Country);

    Country.$inject = ['$resource'];

    function Country ($resource) {
        var resourceUrl =  'api/countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAll': {
                method: 'GET',
                isArray: true,
                url: 'api/countries?size=1000'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('CountrySearch', CountrySearch);

    CountrySearch.$inject = ['$resource'];

    function CountrySearch($resource) {
        var resourceUrl =  'api/_search/countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('CountryController', CountryController);

    CountryController.$inject = ['$state', 'Country', 'CountrySearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CountryController($state, Country, CountrySearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CountrySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Country.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.countries = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ContractStatusDialogController', ContractStatusDialogController);

    ContractStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ContractStatus'];

    function ContractStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ContractStatus) {
        var vm = this;

        vm.contractStatus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.contractStatus.id !== null) {
                ContractStatus.update(vm.contractStatus, onSaveSuccess, onSaveError);
            } else {
                ContractStatus.save(vm.contractStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('adValoremApp:contractStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ContractStatusDetailController', ContractStatusDetailController);

    ContractStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ContractStatus'];

    function ContractStatusDetailController($scope, $rootScope, $stateParams, previousState, entity, ContractStatus) {
        var vm = this;

        vm.contractStatus = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('adValoremApp:contractStatusUpdate', function(event, result) {
            vm.contractStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ContractStatusDeleteController',ContractStatusDeleteController);

    ContractStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'ContractStatus'];

    function ContractStatusDeleteController($uibModalInstance, entity, ContractStatus) {
        var vm = this;

        vm.contractStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ContractStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('contract-status', {
            parent: 'entity',
            url: '/contract-status?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.contractStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/contract-status/contract-statuses.html',
                    controller: 'ContractStatusController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contractStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('contract-status-detail', {
            parent: 'contract-status',
            url: '/contract-status/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.contractStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/contract-status/contract-status-detail.html',
                    controller: 'ContractStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contractStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ContractStatus', function($stateParams, ContractStatus) {
                    return ContractStatus.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'contract-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('contract-status-detail.edit', {
            parent: 'contract-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contract-status/contract-status-dialog.html',
                    controller: 'ContractStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ContractStatus', function(ContractStatus) {
                            return ContractStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contract-status.new', {
            parent: 'contract-status',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contract-status/contract-status-dialog.html',
                    controller: 'ContractStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('contract-status', null, { reload: 'contract-status' });
                }, function() {
                    $state.go('contract-status');
                });
            }]
        })
        .state('contract-status.edit', {
            parent: 'contract-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contract-status/contract-status-dialog.html',
                    controller: 'ContractStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ContractStatus', function(ContractStatus) {
                            return ContractStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('contract-status', null, { reload: 'contract-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contract-status.delete', {
            parent: 'contract-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contract-status/contract-status-delete-dialog.html',
                    controller: 'ContractStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ContractStatus', function(ContractStatus) {
                            return ContractStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('contract-status', null, { reload: 'contract-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('adValoremApp')
        .factory('ContractStatus', ContractStatus);

    ContractStatus.$inject = ['$resource'];

    function ContractStatus ($resource) {
        var resourceUrl =  'api/contract-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('ContractStatusSearch', ContractStatusSearch);

    ContractStatusSearch.$inject = ['$resource'];

    function ContractStatusSearch($resource) {
        var resourceUrl =  'api/_search/contract-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ContractStatusController', ContractStatusController);

    ContractStatusController.$inject = ['$state', 'ContractStatus', 'ContractStatusSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ContractStatusController($state, ContractStatus, ContractStatusSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ContractStatusSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ContractStatus.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.contractStatuses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ContractDialogController', ContractDialogController);

    ContractDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Contract', 'Client', 'ContractStatus'];

    function ContractDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Contract, Client, ContractStatus) {
        var vm = this;

        vm.contract = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.verifyDueDateFormat = verifyDueDateFormat;
        vm.verifyDueDateDay = verifyDueDateDay;
        vm.verifyDueDateMonth = verifyDueDateMonth;
        vm.clients = Client.getAll({filter: 'contract-is-null'});
        $q.all([vm.contract.$promise, vm.clients.$promise]).then(function() {
            if (!vm.contract.client || !vm.contract.client.id) {
                return $q.reject();
            }
            return Client.get({id : vm.contract.client.id}).$promise;
        }).then(function(client) {
            vm.clients.push(client);
        });
        vm.contractstatuses = ContractStatus.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.contract.id !== null) {
                Contract.update(vm.contract, onSaveSuccess, onSaveError);
            } else {
                Contract.save(vm.contract, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('adValoremApp:contractUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dueDate = false;
        vm.datePickerOpenStatus.cancellationDate = false;
        vm.datePickerOpenStatus.suspensionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function verifyDueDateFormat (value) {
            var isFormatValid = true;
            if (value != null) {
                isFormatValid = (value.search(/^\d{2}\/\d{2}$/) >= 0);
            }
            return isFormatValid;
        }

        function verifyDueDateDay (value) {
            var isDueDateDayValid = true;
            if (value != null) {
                var dateArray = value.split('/');
                if (dateArray.length == 2) {
                    var day = parseInt(dateArray[0]);
                    isDueDateDayValid = (day >= 1 && day <= 31);
                }
            }
            return isDueDateDayValid;
        }

        function verifyDueDateMonth (value) {
            var isDueDateMonthValid = true;
            if (value != null) {
                var dateArray = value.split('/');
                if (dateArray.length == 2) {
                    var month = parseInt(dateArray[1]);
                    isDueDateMonthValid = (month >= 1 && month <= 12);
                }
            }
            return isDueDateMonthValid;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ContractDetailController', ContractDetailController);

    ContractDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Contract', 'Client', 'ContractStatus'];

    function ContractDetailController($scope, $rootScope, $stateParams, previousState, entity, Contract, Client, ContractStatus) {
        var vm = this;

        vm.contract = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('adValoremApp:contractUpdate', function(event, result) {
            vm.contract = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ContractDeleteController',ContractDeleteController);

    ContractDeleteController.$inject = ['$uibModalInstance', 'entity', 'Contract'];

    function ContractDeleteController($uibModalInstance, entity, Contract) {
        var vm = this;

        vm.contract = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Contract.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('contract', {
            parent: 'entity',
            url: '/contract?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.contract.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/contract/contracts.html',
                    controller: 'ContractController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contract');
                    $translatePartialLoader.addPart('subdivisionType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('contract-detail', {
            parent: 'contract',
            url: '/contract/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.contract.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/contract/contract-detail.html',
                    controller: 'ContractDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contract');
                    $translatePartialLoader.addPart('subdivisionType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Contract', function($stateParams, Contract) {
                    return Contract.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'contract',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('contract-detail.edit', {
            parent: 'contract-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contract/contract-dialog.html',
                    controller: 'ContractDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Contract', function(Contract) {
                            return Contract.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contract.new', {
            parent: 'contract',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contract/contract-dialog.html',
                    controller: 'ContractDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                company: null,
                                contractNumber: null,
                                dueDate: null,
                                cancellationDate: null,
                                suspensionDate: null,
                                subdivision: null,
                                rcRate: null,
                                vehicleRate: null,
                                minObjectValue: null,
                                maxObjectValue: null,
                                minGlobalValue: null,
                                maxGlobalValue: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('contract', null, { reload: 'contract' });
                }, function() {
                    $state.go('contract');
                });
            }]
        })
        .state('contract.edit', {
            parent: 'contract',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contract/contract-dialog.html',
                    controller: 'ContractDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Contract', function(Contract) {
                            return Contract.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('contract', null, { reload: 'contract' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('contract.delete', {
            parent: 'contract',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contract/contract-delete-dialog.html',
                    controller: 'ContractDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Contract', function(Contract) {
                            return Contract.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('contract', null, { reload: 'contract' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('adValoremApp')
        .factory('Contract', Contract);

    Contract.$inject = ['$resource', 'DateUtils'];

    function Contract ($resource, DateUtils) {
        var resourceUrl =  'api/contracts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.cancellationDate = DateUtils.convertLocalDateFromServer(data.cancellationDate);
                        data.suspensionDate = DateUtils.convertLocalDateFromServer(data.suspensionDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.cancellationDate = DateUtils.convertLocalDateToServer(copy.cancellationDate);
                    copy.suspensionDate = DateUtils.convertLocalDateToServer(copy.suspensionDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.cancellationDate = DateUtils.convertLocalDateToServer(copy.cancellationDate);
                    copy.suspensionDate = DateUtils.convertLocalDateToServer(copy.suspensionDate);
                    return angular.toJson(copy);
                }
            },
            'getByUserLogin': {
                method: 'GET',
                url: 'api/contracts/login/:userLogin'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('ContractSearch', ContractSearch);

    ContractSearch.$inject = ['$resource'];

    function ContractSearch($resource) {
        var resourceUrl =  'api/_search/contracts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ContractController', ContractController);

    ContractController.$inject = ['$state', 'Contract', 'ContractSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ContractController($state, Contract, ContractSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ContractSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Contract.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.contracts = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ClientSuspendController',ClientSuspendController);

    ClientSuspendController.$inject = ['$uibModalInstance', 'entity', 'Client'];

    function ClientSuspendController($uibModalInstance, entity, Client) {
        var vm = this;

        vm.client = entity;
        vm.clear = clear;
        vm.lockForm = lockForm;
        vm.disabled = false;
        vm.confirmSuspend = confirmSuspend;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function lockForm () {
            vm.disabled = true
        }

        function confirmSuspend (id) {
            Client.suspend({id: id},
                function () {
                    $uibModalInstance.close(true);
                },
                lockForm
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ClientSummaryController', ClientSummaryController);

    ClientSummaryController.$inject = ['$timeout', '$state', '$filter', 'entity', 'Client'];

    function ClientSummaryController ($timeout, $state, $filter, entity, Client) {
        var vm = this;

        vm.client = entity;
        vm.datePickerOpenStatus = {};
        vm.clear = clear;
        vm.save = save;
        vm.openCalendar = openCalendar;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        vm.datePickerOpenStatus.period = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear () {
            $state.go('home', null, { relative: false });
        }

        function save () {
            vm.isSaving = true;
            var formattedDate = $filter('date')(vm.period, 'dd/MM/yyyy');
            Client.generateSummary({period: formattedDate}, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $state.go('home', null, { relative: false });
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ClientReactivateController',ClientReactivateController);

    ClientReactivateController.$inject = ['$uibModalInstance', 'entity', 'Client'];

    function ClientReactivateController($uibModalInstance, entity, Client) {
        var vm = this;

        vm.client = entity;
        vm.clear = clear;
        vm.lockForm = lockForm;
        vm.disabled = false;
        vm.confirmReactivate = confirmReactivate;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function lockForm () {
            vm.disabled = true
        }

        function confirmReactivate (id) {
            Client.reactivate({id: id},
                function () {
                    $uibModalInstance.close(true);
                },
                lockForm
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ClientDialogController', ClientDialogController);

    ClientDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Client', 'Facility', 'DommageRate', 'AdValoremDocument', 'AccsUser', 'Guarantee'];

    function ClientDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Client, Facility, DommageRate, AdValoremDocument, AccsUser, Guarantee) {
        var vm = this;

        vm.client = entity;
        vm.clear = clear;
        vm.save = save;
        vm.facilities = Facility.query();
        vm.dommagerates = DommageRate.query();
        vm.advaloremdocuments = AdValoremDocument.query();
        vm.accsusers = AccsUser.query();
        vm.guarantees = Guarantee.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.client.id !== null) {
                Client.update(vm.client, onSaveSuccess, onSaveError);
            } else {
                Client.save(vm.client, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('adValoremApp:clientUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ClientDetailController', ClientDetailController);

    ClientDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Client', 'Facility', 'DommageRate', 'AdValoremDocument', 'AccsUser', 'Guarantee'];

    function ClientDetailController($scope, $rootScope, $stateParams, previousState, entity, Client, Facility, DommageRate, AdValoremDocument, AccsUser, Guarantee) {
        var vm = this;

        vm.client = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('adValoremApp:clientUpdate', function(event, result) {
            vm.client = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('client', {
            parent: 'entity',
            url: '/client?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.client.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/client/clients.html',
                    controller: 'ClientController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('client');
                    $translatePartialLoader.addPart('statusClient');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('client-detail', {
            parent: 'client',
            url: '/client/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.client.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/client/client-detail.html',
                    controller: 'ClientDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('client');
                    $translatePartialLoader.addPart('statusClient');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Client', function($stateParams, Client) {
                    return Client.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'client',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('client-detail.edit', {
            parent: 'client-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/client/client-dialog.html',
                    controller: 'ClientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Client', function(Client) {
                            return Client.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('client.new', {
            parent: 'client',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/client/client-dialog.html',
                    controller: 'ClientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                email: null,
                                businessId: null,
                                address1: null,
                                address2: null,
                                address3: null,
                                postalCode: null,
                                city: null,
                                phoneNumber: null,
                                faxNumber: null,
                                status: 'ACTIF',
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('client', null, { reload: 'client' });
                }, function() {
                    $state.go('client');
                });
            }]
        })
        .state('client.edit', {
            parent: 'client',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/client/client-dialog.html',
                    controller: 'ClientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Client', function(Client) {
                            return Client.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('client', null, { reload: 'client' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('client.suspend', {
            parent: 'client',
            url: '/{id}/suspend',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/client/client-suspend-dialog.html',
                    controller: 'ClientSuspendController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Client', function(Client) {
                            return Client.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('client', null, { reload: 'client' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('client.reactivate', {
            parent: 'client',
            url: '/{id}/reactivate',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/client/client-reactivate-dialog.html',
                    controller: 'ClientReactivateController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Client', function(Client) {
                            return Client.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                        $state.go('client', null, { reload: 'client' });
                    }, function() {
                        $state.go('^');
                    });
            }]
        })
        .state('client.summary', {
            parent: 'client',
            url: '/summary',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/client/client-summary.html',
                    controller: 'ClientSummaryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('client');
                    $translatePartialLoader.addPart('statusClient');
                    return $translate.refresh();
                }],
                entity: function() {
                    return {
                        period: null
                    }
                }
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('adValoremApp')
        .factory('Client', Client);

    Client.$inject = ['$resource'];

    function Client ($resource) {
        var resourceUrl =  'api/clients/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'suspend': {
                method: 'POST',
                params: {id: '@id'},
                url: 'api/clients/suspend/:id'
            },
            'reactivate': {
                method: 'POST',
                params: {id: '@id'},
                url: 'api/clients/reactivate/:id'
            },
            'generateSummary': {
                method: 'POST',
                params: {summaryDate: '@period'},
                url: 'api/clients/summary/generate'
            },
            'getAll': {
                method: 'GET',
                isArray: true,
                url: 'api/clients?size=1000'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('ClientSearch', ClientSearch);

    ClientSearch.$inject = ['$resource'];

    function ClientSearch($resource) {
        var resourceUrl =  'api/_search/clients/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ClientController', ClientController);

    ClientController.$inject = ['$state', 'Client', 'ClientSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ClientController($state, Client, ClientSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ClientSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Client.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.clients = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('AdValoremLibraryController', AdValoremLibraryController);

    AdValoremLibraryController.$inject = ['$state', 'DataUtils', 'AdValoremDocument', 'AdValoremDocumentSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Principal'];

    function AdValoremLibraryController($state, DataUtils, AdValoremDocument, AdValoremDocumentSearch, ParseLinks, AlertService, paginationConstants, pagingParams, Principal) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.loadLibrary = loadLibrary;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        vm.userLogin = null;
        Principal.identity().then(function(account) {
            vm.userLogin = account.login;
            loadLibrary(vm.userLogin);
        });


        function loadLibrary (userLogin) {
            if (pagingParams.search) {
                AdValoremDocumentSearch.queryByLogin({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    userLogin: userLogin
                }, onSuccess, onError);
            } else {
                AdValoremDocument.queryByLogin({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    userLogin: userLogin
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.adValoremDocuments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('AdValoremDocumentDialogController', AdValoremDocumentDialogController);

    AdValoremDocumentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'AdValoremDocument', 'Client'];

    function AdValoremDocumentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, AdValoremDocument, Client) {
        var vm = this;

        vm.adValoremDocument = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.clients = Client.getAll();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.adValoremDocument.id !== null) {
                AdValoremDocument.update(vm.adValoremDocument, onSaveSuccess, onSaveError);
            } else {
                AdValoremDocument.save(vm.adValoremDocument, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('adValoremApp:adValoremDocumentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setData = function ($file, adValoremDocument) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        adValoremDocument.data = base64Data;
                        adValoremDocument.dataContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('AdValoremDocumentDetailController', AdValoremDocumentDetailController);

    AdValoremDocumentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'AdValoremDocument', 'Client'];

    function AdValoremDocumentDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, AdValoremDocument, Client) {
        var vm = this;

        vm.adValoremDocument = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('adValoremApp:adValoremDocumentUpdate', function(event, result) {
            vm.adValoremDocument = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('AdValoremDocumentDeleteController',AdValoremDocumentDeleteController);

    AdValoremDocumentDeleteController.$inject = ['$uibModalInstance', 'entity', 'AdValoremDocument'];

    function AdValoremDocumentDeleteController($uibModalInstance, entity, AdValoremDocument) {
        var vm = this;

        vm.adValoremDocument = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AdValoremDocument.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ad-valorem-document', {
            parent: 'entity',
            url: '/ad-valorem-document?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.adValoremDocument.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ad-valorem-document/ad-valorem-documents.html',
                    controller: 'AdValoremDocumentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('adValoremDocument');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ad-valorem-library', {
            parent: 'entity',
            url: '/ad-valorem-library?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'adValoremApp.adValoremDocument.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ad-valorem-document/ad-valorem-library.html',
                    controller: 'AdValoremLibraryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('adValoremDocument');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ad-valorem-document-detail', {
            parent: 'ad-valorem-document',
            url: '/ad-valorem-document/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.adValoremDocument.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ad-valorem-document/ad-valorem-document-detail.html',
                    controller: 'AdValoremDocumentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('adValoremDocument');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AdValoremDocument', function($stateParams, AdValoremDocument) {
                    return AdValoremDocument.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ad-valorem-document',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ad-valorem-document-detail.edit', {
            parent: 'ad-valorem-document-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ad-valorem-document/ad-valorem-document-dialog.html',
                    controller: 'AdValoremDocumentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AdValoremDocument', function(AdValoremDocument) {
                            return AdValoremDocument.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ad-valorem-document.new', {
            parent: 'ad-valorem-document',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ad-valorem-document/ad-valorem-document-dialog.html',
                    controller: 'AdValoremDocumentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                data: null,
                                type: null,
                                dataContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ad-valorem-document', null, { reload: 'ad-valorem-document' });
                }, function() {
                    $state.go('ad-valorem-document');
                });
            }]
        })
        .state('ad-valorem-document.edit', {
            parent: 'ad-valorem-document',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ad-valorem-document/ad-valorem-document-dialog.html',
                    controller: 'AdValoremDocumentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AdValoremDocument', function(AdValoremDocument) {
                            return AdValoremDocument.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ad-valorem-document', null, { reload: 'ad-valorem-document' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ad-valorem-document.delete', {
            parent: 'ad-valorem-document',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ad-valorem-document/ad-valorem-document-delete-dialog.html',
                    controller: 'AdValoremDocumentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AdValoremDocument', function(AdValoremDocument) {
                            return AdValoremDocument.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ad-valorem-document', null, { reload: 'ad-valorem-document' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('adValoremApp')
        .factory('AdValoremDocument', AdValoremDocument);

    AdValoremDocument.$inject = ['$resource'];

    function AdValoremDocument ($resource) {
        var resourceUrl =  'api/ad-valorem-documents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryByLogin': {
                method: 'GET',
                isArray: true,
                params: {userLogin: 'userLogin'}
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('AdValoremDocumentSearch', AdValoremDocumentSearch);

    AdValoremDocumentSearch.$inject = ['$resource'];

    function AdValoremDocumentSearch($resource) {
        var resourceUrl =  'api/_search/ad-valorem-documents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByLogin': {
                method: 'GET',
                params: {userLogin: 'userLogin'},
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('AdValoremDocumentController', AdValoremDocumentController);

    AdValoremDocumentController.$inject = ['$state', 'DataUtils', 'AdValoremDocument', 'AdValoremDocumentSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function AdValoremDocumentController($state, DataUtils, AdValoremDocument, AdValoremDocumentSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                AdValoremDocumentSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                AdValoremDocument.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.adValoremDocuments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('AccsUserDialogController', AccsUserDialogController);

    AccsUserDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'AccsUser', 'User', 'Client'];

    function AccsUserDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, AccsUser, User, Client) {
        var vm = this;

        vm.accsUser = entity;
        vm.clear = clear;
        vm.save = save;
        vm.users = User.getAll();
        vm.clients = Client.getAll();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.accsUser.id !== null) {
                AccsUser.update(vm.accsUser, onSaveSuccess, onSaveError);
            } else {
                AccsUser.save(vm.accsUser, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('adValoremApp:accsUserUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('AccsUserDetailController', AccsUserDetailController);

    AccsUserDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AccsUser', 'User', 'Client'];

    function AccsUserDetailController($scope, $rootScope, $stateParams, previousState, entity, AccsUser, User, Client) {
        var vm = this;

        vm.accsUser = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('adValoremApp:accsUserUpdate', function(event, result) {
            vm.accsUser = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('AccsUserDeleteController',AccsUserDeleteController);

    AccsUserDeleteController.$inject = ['$uibModalInstance', 'entity', 'AccsUser'];

    function AccsUserDeleteController($uibModalInstance, entity, AccsUser) {
        var vm = this;

        vm.accsUser = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AccsUser.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('accs-user', {
            parent: 'entity',
            url: '/accs-user?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.accsUser.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/accs-user/accs-users.html',
                    controller: 'AccsUserController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('accsUser');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('accs-user-detail', {
            parent: 'accs-user',
            url: '/accs-user/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'adValoremApp.accsUser.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/accs-user/accs-user-detail.html',
                    controller: 'AccsUserDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('accsUser');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AccsUser', function($stateParams, AccsUser) {
                    return AccsUser.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'accs-user',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('accs-user-detail.edit', {
            parent: 'accs-user-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/accs-user/accs-user-dialog.html',
                    controller: 'AccsUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AccsUser', function(AccsUser) {
                            return AccsUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('accs-user.new', {
            parent: 'accs-user',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/accs-user/accs-user-dialog.html',
                    controller: 'AccsUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                phoneNumber: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('accs-user', null, { reload: 'accs-user' });
                }, function() {
                    $state.go('accs-user');
                });
            }]
        })
        .state('accs-user.edit', {
            parent: 'accs-user',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/accs-user/accs-user-dialog.html',
                    controller: 'AccsUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AccsUser', function(AccsUser) {
                            return AccsUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('accs-user', null, { reload: 'accs-user' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('accs-user.delete', {
            parent: 'accs-user',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/accs-user/accs-user-delete-dialog.html',
                    controller: 'AccsUserDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AccsUser', function(AccsUser) {
                            return AccsUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('accs-user', null, { reload: 'accs-user' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('adValoremApp')
        .factory('AccsUser', AccsUser);

    AccsUser.$inject = ['$resource'];

    function AccsUser ($resource) {
        var resourceUrl =  'api/accs-users/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('AccsUserSearch', AccsUserSearch);

    AccsUserSearch.$inject = ['$resource'];

    function AccsUserSearch($resource) {
        var resourceUrl =  'api/_search/accs-users/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('AccsUserController', AccsUserController);

    AccsUserController.$inject = ['$state', 'AccsUser', 'AccsUserSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function AccsUserController($state, AccsUser, AccsUserSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                AccsUserSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                AccsUser.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.accsUsers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('adValoremApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Affichage de {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'sur {{$ctrl.queryCount}} éléments.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('adValoremApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            var binStr = atob( data );
            var len = binStr.length;
            var arr = new Uint8Array(len);
            for (var i = 0; i < len; i++) {
                arr[ i ] = binStr.charCodeAt( i );
            }
            var blob =  new Blob( [ arr ], { type: 'application/pdf' } );
            var url = URL.createObjectURL( blob );
            $window.open(url,'_blank');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('adValoremApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('LoginNoDialogController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth'];

    function LoginController ($rootScope, $state, $timeout, Auth) {
        var vm = this;

        vm.authenticationError = false;
        vm.authenticationErrorMessage = "";
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                vm.authenticationErrorMessage = "";
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset' ||
                    $state.current.name === 'jhi-login') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    if (previousState.name == 'jhi-login') {
                        Auth.resetPreviousState();
                        $state.go('home');
                    } else {
                        Auth.resetPreviousState();
                        $state.go(previousState.name, previousState.params);
                    }
                }
            }).catch(function (response) {
                vm.authenticationError = true;
                vm.authenticationErrorMessage = response.headers("message");
            });
        }

        function register () {
            $state.go('register');
        }

        function requestResetPassword () {
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-login', {
            parent: 'account',
            url: '/login',
            data: {
                authorities: [],
                pageTitle: 'login.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/login/login-nodialog.html',
                    controller: 'LoginNoDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('login');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$state'];

    function LoginService ($state) {
        var service = {
            open: open
        };

        return service;

        function open () {
            $state.go('jhi-login');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function (response) {
                vm.authenticationError = true;
                vm.authenticationErrorMessage = response.headers("message");
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'hy': 'Հայերեն',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('adValoremApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'fr'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('adValoremApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('adValoremApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('adValoremApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('adValoremApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('adValoremApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector'];

    function authExpiredInterceptor($rootScope, $q, $injector) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
                var LoginService = $injector.get('LoginService');
                LoginService.open();
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('adValoremApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "fr"');
                $cookies.putObject(name, 'fr');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('fr');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('guarantee');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('adValoremApp')
        .constant('VERSION', "1.0.10")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/user/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.indexOf('jcache.statistics') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('adValoremApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ElasticsearchReindexDialogController', ElasticsearchReindexDialogController);

    ElasticsearchReindexDialogController.$inject = ['$uibModalInstance', 'ElasticsearchReindex'];

    function ElasticsearchReindexDialogController($uibModalInstance, ElasticsearchReindex) {
        var vm = this;

        vm.clear = clear;
        vm.confirmReindex = confirmReindex;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReindex() {
            ElasticsearchReindex.reindex(function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('elasticsearch-reindex', {
            parent: 'admin',
            url: '/elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'elasticsearch.reindex.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex.html',
                    controller: 'ElasticsearchReindexController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('elasticsearch-reindex');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('elasticsearch-reindex.dialog', {
            parent: 'elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html',
                    controller: 'ElasticsearchReindexDialogController',
                    controllerAs: 'vm',
                    size: 'sm'
                }).result.finally(function () {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('ElasticsearchReindex', ElasticsearchReindex);

    ElasticsearchReindex.$inject = ['$resource'];

    function ElasticsearchReindex($resource) {
        var service = $resource('api/elasticsearch/index', {}, {
            'reindex': {method: 'POST'}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ElasticsearchReindexController', ElasticsearchReindexController);

    ElasticsearchReindexController.$inject = [];

    function ElasticsearchReindexController() {
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.checkPassword = checkPassword;
        vm.checkNotContainsAccents = checkNotContainsAccents;
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function checkPassword(value) {
            var passwordValid = true;
            if(value != null) {
                if (value.search(/[A-Z]/) == -1) {
                    // le mot de passe doit contenir au moins une lettre majuscule
                    passwordValid = false;
                }
                if (value.search(/[a-z]/) == -1) {
                    // le mot de passe doit contenir au moins une lettre minuscule
                    passwordValid = false;
                }
                if (value.search(/\d/) == -1) {
                    // le mot de passe doit contenir au moins un chiffre
                    passwordValid = false;
                }
                if (value.search(/\W/) == -1) {
                    // le mot de passe doit contenir au moins un caractère spécial
                    passwordValid = false;
                }
            }

            return passwordValid;
        }

        function checkNotContainsAccents(value) {
            // le mot de passe ne doit pas contenir de caractères accentués
            if (value != null) {
                return value.search(/[À-ÿ]/) == -1;
            } else {
                return true;
            }
        }

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.checkPassword = checkPassword;
        vm.checkNotContainsAccents = checkNotContainsAccents;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function checkPassword(value) {
            var passwordValid = true;
            if(value != null) {
                if (value.search(/[A-Z]/) == -1) {
                    // le mot de passe doit contenir au moins une lettre majuscule
                    passwordValid = false;
                }
                if (value.search(/[a-z]/) == -1) {
                    // le mot de passe doit contenir au moins une lettre minuscule
                    passwordValid = false;
                }
                if (value.search(/\d/) == -1) {
                    // le mot de passe doit contenir au moins un chiffre
                    passwordValid = false;
                }
                if (value.search(/\W/) == -1) {
                    // le mot de passe doit contenir au moins un caractère spécial
                    passwordValid = false;
                }
            }

            return passwordValid;
        }

        function checkNotContainsAccents(value) {
            // le mot de passe ne doit pas contenir de caractères accentués
            if (value != null) {
                return value.search(/[À-ÿ]/) == -1;
            } else {
                return true;
            }
        }

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('adValoremApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('adValoremApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><jhi-alert></jhi-alert><div class="row"><div class="col-md-12"><h4 class="modal-title" data-translate="home.title">My services</h4><div class="row home-buttons"><div class="col-md-2 home-button" has-authority="ROLE_USER"><a ui-sref="guarantee.new.devis"><img src="content/images/icone-devis.png" alt="Quotation button"> <span data-translate="adValoremApp.guarantee.home.createDevis">Quotation</span></a></div><div class="col-md-2 home-button" has-authority="ROLE_USER"><a ui-sref="guarantee.new.nodialog"><img src="content/images/icone-garantie.png" alt="Guarantee button"> <span data-translate="adValoremApp.guarantee.home.createLabel">New Guarantee</span></a></div><div class="col-md-2 home-button" has-authority="ROLE_USER"><a ui-sref="ad-valorem-library"><img src="content/images/icone-documents.png" alt="Library button"> <span data-translate="global.menu.library">Library</span></a></div><div class="col-md-2 home-button"><a ui-sref="settings"><img src="content/images/icone-comtpe.png" alt="My account button"> <span data-translate="global.menu.account.main">Account</span></a></div></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ui-validate="{isValid: \'vm.checkPassword($value)\', notContainsAccents: \'vm.checkNotContainsAccents($value)\'}" ng-model="vm.password" ng-minlength="8" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 8 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.password.$error.isValid" data-translate="global.messages.validate.newpassword.invalid">Your password is invalid.</p><p class="help-block" ng-show="form.password.$error.notContainsAccents" data-translate="global.messages.validate.newpassword.containsAccentedCharacters">Your password must not contains accented characters</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="8" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 8 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h2 data-translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="sessions.table.ipaddress">IP Address</th><th data-translate="sessions.table.useragent">User agent</th><th data-translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" data-translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html','<form name="reindexForm" ng-submit="vm.confirmReindex()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="elasticsearch.reindex.dialog.title">Confirm reindex operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="elasticsearch.reindex.dialog.question">Are you sure you want to reindex Elasticsearch? This could take a while!</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.confirm">Reindex</span></button></div></form>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex.html','<div class="clearfix"><h1 data-translate="elasticsearch.reindex.title">Reindex Elasticsearch</h1><jhi-alert></jhi-alert><p data-translate="elasticsearch.reindex.instructions1">This will send a request to reindex all data from your primary datasource into Elasticsearch. This will fix missing data and mapping issues, however you will lose any ES data and mapping that was defined outside of your application. This request will return immediately and the reindexing will run in the background. You will see "Elasticsearch: Successfully performed reindexing" in your logs when this is complete.</p><p data-translate="elasticsearch.reindex.instructions2">This can take a long time and is susceptible to concurrency issues so it should be performed when the number of users is low.</p><button type="button" class="btn btn-primary pull-right" ui-sref="elasticsearch-reindex.dialog"><span class="glyphicon glyphicon-exclamation-sign"></span> <span data-translate="elasticsearch.reindex.go">Go</span></button></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.cache.title">Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.cache.cachename">Cache name</th><th class="text-right" data-translate="metrics.cache.hits">Cache Hits</th><th class="text-right" data-translate="metrics.cache.misses">Cache Misses</th><th class="text-right" data-translate="metrics.cache.gets">Cache Gets</th><th class="text-right" data-translate="metrics.cache.puts">Cache Puts</th><th class="text-right" data-translate="metrics.cache.removals">Cache Removals</th><th class="text-right" data-translate="metrics.cache.evictions">Cache Evictions</th><th class="text-right" data-translate="metrics.cache.hitPercent">Cache Hit %</th><th class="text-right" data-translate="metrics.cache.missPercent">Cache Miss %</th><th class="text-right" data-translate="metrics.cache.averageGetTime">Average get time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averagePutTime">Average put time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averageRemoveTime">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="row jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="true" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" ng-disabled="true" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="true" data-translate="userManagement.activated">Activated</button></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login-nodialog.html','<div class="modal-header"><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="{{vm.authenticationErrorMessage}}"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form-horizontal text-center" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" class="col-sm-4 control-label" data-translate="global.form.username">Login</label><div class="col-sm-4"><input type="text" class="form-control form-login" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div></div><div class="form-group"><label for="password" class="col-sm-4 control-label" data-translate="login.form.password">Password</label><div class="col-sm-4"><input type="password" class="form-control form-login" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button><div class="form-group forgotten-password-link"><a href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div></form><p></p></div></div><div class="row link-assurdem"><div class="col-md-8 col-md-offset-2 text-center"><a href="https://www.assurdem.fr/"><span data-translate="login.backTo">Back to</span> <img class="logo-img" src="content/images/logo-assurdem.png" alt="Logo Assurdem"></a></div></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="{{vm.authenticationErrorMessage}}"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div></div></div></div>');
$templateCache.put('app/entities/accs-user/accs-user-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.accsUser.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="adValoremApp.accsUser.delete.question" translate-values="{id: \'{{vm.accsUser.id}}\'}">Are you sure you want to delete this Accs User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/accs-user/accs-user-detail.html','<div><h2><span data-translate="adValoremApp.accsUser.detail.title">Accs User</span> {{vm.accsUser.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="adValoremApp.accsUser.phoneNumber">Phone Number</span></dt><dd><span>{{vm.accsUser.phoneNumber}}</span></dd><dt><span data-translate="adValoremApp.accsUser.user">User</span></dt><dd>{{vm.accsUser.user.login}}</dd><dt><span data-translate="adValoremApp.accsUser.client">Client</span></dt><dd><a ui-sref="client-detail({id:vm.accsUser.client.id})">{{vm.accsUser.client.name}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="accs-user-detail.edit({id:vm.accsUser.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/accs-user/accs-user-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAccsUserLabel" data-translate="adValoremApp.accsUser.home.createOrEditLabel">Create or edit a Accs User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.accsUser.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.accsUser.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.accsUser.phoneNumber" for="field_phoneNumber">Phone Number</label><input type="text" class="form-control" name="phoneNumber" id="field_phoneNumber" ng-model="vm.accsUser.phoneNumber" required><div ng-show="editForm.phoneNumber.$invalid"><p class="help-block" ng-show="editForm.phoneNumber.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="adValoremApp.accsUser.user" for="field_user">User</label><select class="form-control" id="field_user" name="user" ng-model="vm.accsUser.user" ng-options="user as user.login for user in vm.users | orderBy:\'login\' track by user.id" required><option value=""></option></select></div><div ng-show="editForm.user.$invalid"><p class="help-block" ng-show="editForm.user.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="adValoremApp.accsUser.client" for="field_client">Client</label><select class="form-control" id="field_client" name="client" ng-model="vm.accsUser.client" ng-options="client as client.name for client in vm.clients | orderBy:\'name\' track by client.id" required><option value=""></option></select></div><div ng-show="editForm.client.$invalid"><p class="help-block" ng-show="editForm.client.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/accs-user/accs-users.html','<div><h2 data-translate="adValoremApp.accsUser.home.title">Accs Users</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="accs-user.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="adValoremApp.accsUser.home.createLabel">Create new Accs User</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'adValoremApp.accsUser.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phoneNumber"><span data-translate="adValoremApp.accsUser.phoneNumber">Phone Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="user.login"><span data-translate="adValoremApp.accsUser.user">User</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="client.name"><span data-translate="adValoremApp.accsUser.client">Client</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="accsUser in vm.accsUsers track by accsUser.id"><td><a ui-sref="accs-user-detail({id:accsUser.id})">{{accsUser.id}}</a></td><td>{{accsUser.phoneNumber}}</td><td>{{accsUser.user.login}}</td><td><a ui-sref="client-detail({id:accsUser.client.id})">{{accsUser.client.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="accs-user-detail({id:accsUser.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="accs-user.edit({id:accsUser.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="accs-user.delete({id:accsUser.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/ad-valorem-document/ad-valorem-document-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.adValoremDocument.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="adValoremApp.adValoremDocument.delete.question" translate-values="{id: \'{{vm.adValoremDocument.id}}\'}">Are you sure you want to delete this Ad Valorem Document?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ad-valorem-document/ad-valorem-document-detail.html','<div><h2><span data-translate="adValoremApp.adValoremDocument.detail.title">Ad Valorem Document</span> {{vm.adValoremDocument.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="adValoremApp.adValoremDocument.name">Name</span></dt><dd><span>{{vm.adValoremDocument.name}}</span></dd><dt><span data-translate="adValoremApp.adValoremDocument.type">Type</span></dt><dd><span>{{vm.adValoremDocument.type}}</span></dd><dt><span data-translate="adValoremApp.adValoremDocument.data">Data</span></dt><dd><div ng-if="vm.adValoremDocument.data"><a ng-click="vm.openFile(vm.adValoremDocument.dataContentType, vm.adValoremDocument.data)" data-translate="entity.action.open">open</a> {{vm.adValoremDocument.dataContentType}}, {{vm.byteSize(vm.adValoremDocument.data)}}</div></dd><dt><span data-translate="adValoremApp.adValoremDocument.client">Client</span></dt><dd><a ui-sref="client-detail({id:vm.adValoremDocument.client.id})">{{vm.adValoremDocument.client.name}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ad-valorem-document-detail.edit({id:vm.adValoremDocument.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/ad-valorem-document/ad-valorem-document-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAdValoremDocumentLabel" data-translate="adValoremApp.adValoremDocument.home.createOrEditLabel">Create or edit a Ad Valorem Document</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.adValoremDocument.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.adValoremDocument.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.adValoremDocument.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.adValoremDocument.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.adValoremDocument.type" for="field_type">Type</label><input type="text" class="form-control" name="type" id="field_type" ng-model="vm.adValoremDocument.type"></div><div class="form-group" ngf-drop ngf-change="vm.setData($file, vm.adValoremDocument)"><label class="control-label" data-translate="adValoremApp.adValoremDocument.data" for="field_data">Data</label><div><div ng-if="vm.adValoremDocument.data" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.adValoremDocument.dataContentType, vm.adValoremDocument.data)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.adValoremDocument.dataContentType}}, {{vm.byteSize(vm.adValoremDocument.data)}}</span> <button type="button" ng-click="vm.adValoremDocument.data=null;vm.adValoremDocument.dataContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setData($file, vm.adValoremDocument)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="data" id="field_data" ng-model="vm.adValoremDocument.data" required> <input type="hidden" class="form-control" name="dataContentType" id="field_dataContentType" ng-model="vm.adValoremDocument.dataContentType"><div ng-show="editForm.data.$invalid"><p class="help-block" ng-show="editForm.data.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="adValoremApp.adValoremDocument.client" for="field_client">Client</label><select class="form-control" id="field_client" name="client" ng-model="vm.adValoremDocument.client" ng-options="client as client.name for client in vm.clients | orderBy:\'name\' track by client.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ad-valorem-document/ad-valorem-documents.html','<div><h2 data-translate="adValoremApp.adValoremDocument.home.title">Ad Valorem Documents</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ad-valorem-document.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="adValoremApp.adValoremDocument.home.createLabel">Create new Ad Valorem Document</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'adValoremApp.adValoremDocument.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="adValoremApp.adValoremDocument.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="adValoremApp.adValoremDocument.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="data"><span data-translate="adValoremApp.adValoremDocument.data">Data</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="client.name"><span data-translate="adValoremApp.adValoremDocument.client">Client</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="adValoremDocument in vm.adValoremDocuments track by adValoremDocument.id"><td><a ui-sref="ad-valorem-document-detail({id:adValoremDocument.id})">{{adValoremDocument.id}}</a></td><td>{{adValoremDocument.name}}</td><td>{{adValoremDocument.type}}</td><td><a ng-if="adValoremDocument.data" ng-click="vm.openFile(adValoremDocument.dataContentType, adValoremDocument.data)" data-translate="entity.action.open">open</a> <span ng-if="adValoremDocument.data">{{adValoremDocument.dataContentType}}, {{vm.byteSize(adValoremDocument.data)}}</span></td><td><a ui-sref="client-detail({id:adValoremDocument.client.id})">{{adValoremDocument.client.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ad-valorem-document-detail({id:adValoremDocument.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="ad-valorem-document.edit({id:adValoremDocument.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="ad-valorem-document.delete({id:adValoremDocument.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/ad-valorem-document/ad-valorem-library.html','<div><h2 data-translate="global.menu.library">Library</h2><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="adValoremApp.adValoremDocument.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="adValoremApp.adValoremDocument.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="adValoremDocument in vm.adValoremDocuments track by adValoremDocument.id"><td>{{adValoremDocument.name}}</td><td>{{adValoremDocument.type}}</td><td class="text-right"><div class="btn-group flex-btn-group-container library-download-link"><a ng-if="adValoremDocument.data" ng-click="vm.openFile(adValoremDocument.dataContentType, adValoremDocument.data)"><img class="download-icon" src="content/images/icone-download.png" alt="Ic\xF4ne t\xE9l\xE9chargement"> {{\'entity.action.download\' | translate}}</a></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/client/client-detail.html','<div><h2><span data-translate="adValoremApp.client.detail.title">Client</span> {{vm.client.businessId}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="adValoremApp.client.name">Name</span></dt><dd><span>{{vm.client.name}}</span></dd><dt><span data-translate="adValoremApp.client.email">Email</span></dt><dd><span>{{vm.client.email}}</span></dd><dt><span data-translate="adValoremApp.client.businessId">Business Id</span></dt><dd><span>{{vm.client.businessId}}</span></dd><dt><span data-translate="adValoremApp.client.address1">Address 1</span></dt><dd><span>{{vm.client.address1}}</span></dd><dt><span data-translate="adValoremApp.client.address2">Address 2</span></dt><dd><span>{{vm.client.address2}}</span></dd><dt><span data-translate="adValoremApp.client.address3">Address 3</span></dt><dd><span>{{vm.client.address3}}</span></dd><dt><span data-translate="adValoremApp.client.postalCode">Postal Code</span></dt><dd><span>{{vm.client.postalCode}}</span></dd><dt><span data-translate="adValoremApp.client.city">City</span></dt><dd><span>{{vm.client.city}}</span></dd><dt><span data-translate="adValoremApp.client.phoneNumber">Phone Number</span></dt><dd><span>{{vm.client.phoneNumber}}</span></dd><dt><span data-translate="adValoremApp.client.faxNumber">Fax Number</span></dt><dd><span>{{vm.client.faxNumber}}</span></dd><dt><span data-translate="adValoremApp.client.status">Status</span></dt><dd><span data-translate="{{\'adValoremApp.StatusClient.\' + vm.client.status}}">{{vm.client.status}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="client-detail.edit({id:vm.client.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/client/client-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myClientLabel" data-translate="adValoremApp.client.home.createOrEditLabel">Create or edit a Client</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.client.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.client.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.client.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.client.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.client.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.client.email" required><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.client.businessId" for="field_businessId">Business Id</label><input type="text" class="form-control" name="businessId" id="field_businessId" ng-model="vm.client.businessId" required><div ng-show="editForm.businessId.$invalid"><p class="help-block" ng-show="editForm.businessId.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.client.address1" for="field_address1">Address 1</label><input type="text" class="form-control" name="address1" id="field_address1" ng-model="vm.client.address1" required><div ng-show="editForm.address1.$invalid"><p class="help-block" ng-show="editForm.address1.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.client.address2" for="field_address2">Address 2</label><input type="text" class="form-control" name="address2" id="field_address2" ng-model="vm.client.address2"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.client.address3" for="field_address3">Address 3</label><input type="text" class="form-control" name="address3" id="field_address3" ng-model="vm.client.address3"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.client.postalCode" for="field_postalCode">Postal Code</label><input type="text" class="form-control" name="postalCode" id="field_postalCode" ng-model="vm.client.postalCode" required><div ng-show="editForm.postalCode.$invalid"><p class="help-block" ng-show="editForm.postalCode.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.client.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.client.city" required><div ng-show="editForm.city.$invalid"><p class="help-block" ng-show="editForm.city.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.client.phoneNumber" for="field_phoneNumber">Phone Number</label><input type="text" class="form-control" name="phoneNumber" id="field_phoneNumber" ng-model="vm.client.phoneNumber" required><div ng-show="editForm.phoneNumber.$invalid"><p class="help-block" ng-show="editForm.phoneNumber.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.client.faxNumber" for="field_faxNumber">Fax Number</label><input type="text" class="form-control" name="faxNumber" id="field_faxNumber" ng-model="vm.client.faxNumber" required><div ng-show="editForm.faxNumber.$invalid"><p class="help-block" ng-show="editForm.faxNumber.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.client.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.client.status" id="field_status" required disabled="disabled"><option value="ACTIF" data-translate="adValoremApp.StatusClient.ACTIF">ACTIF</option><option value="SUSPENDU" data-translate="adValoremApp.StatusClient.SUSPENDU">SUSPENDU</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/client/client-reactivate-dialog.html','<form name="reactivateForm" ng-submit="vm.confirmReactivate(vm.client.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="adValoremApp.client.reactivate.title">Confirm reactivate operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="adValoremApp.client.reactivate.question" translate-values="{id: \'{{vm.client.id}}\'}">Are you sure you want to reactivate this Client?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="reactivateForm.$invalid ||\xA0vm.disabled" class="btn btn-primary"><span data-translate="adValoremApp.client.reactivate.action">reactivate</span></button></div></form>');
$templateCache.put('app/entities/client/client-summary.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><h4 class="modal-title" id="myClientLabel" data-translate="adValoremApp.summary.title">Generate summary</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="adValoremApp.summary.period" for="field_period">Period</label><div class="input-group"><input id="field_period" type="text" class="form-control" name="period" uib-datepicker-popup="{{dateformat}}" ng-model="vm.period" is-open="vm.datePickerOpenStatus.period" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'period\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.period.$invalid"><p class="help-block" ng-show="editForm.period.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="adValoremApp.summary.generate">Generate</span></button></div></form>');
$templateCache.put('app/entities/client/client-suspend-dialog.html','<form name="suspendForm" ng-submit="vm.confirmSuspend(vm.client.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="adValoremApp.client.suspend.title">Confirm suspend operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="adValoremApp.client.suspend.question" translate-values="{id: \'{{vm.client.id}}\'}">Are you sure you want to suspend this Client?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="suspendForm.$invalid ||\xA0vm.disabled" class="btn btn-danger"><span data-translate="adValoremApp.client.suspend.action">suspend</span></button></div></form>');
$templateCache.put('app/entities/client/clients.html','<div><h2 data-translate="adValoremApp.client.home.title">Clients</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="client.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="adValoremApp.client.home.createLabel">Create new Client</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'adValoremApp.client.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="businessId"><span data-translate="adValoremApp.client.businessId">Business Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="adValoremApp.client.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="adValoremApp.client.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="address1"><span data-translate="adValoremApp.client.address1">Address 1</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="address2"><span data-translate="adValoremApp.client.address2">Address 2</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="address3"><span data-translate="adValoremApp.client.address3">Address 3</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="postalCode"><span data-translate="adValoremApp.client.postalCode">Postal Code</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="city"><span data-translate="adValoremApp.client.city">City</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="phoneNumber"><span data-translate="adValoremApp.client.phoneNumber">Phone Number</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="faxNumber"><span data-translate="adValoremApp.client.faxNumber">Fax Number</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="status"><span data-translate="adValoremApp.client.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="client in vm.clients track by client.id"><td><a ui-sref="client-detail({id:client.id})">{{client.businessId}}</a></td><td>{{client.name}}</td><td>{{client.email}}</td><!--<td>{{client.address1}}</td>--><!--<td>{{client.address2}}</td>--><!--<td>{{client.address3}}</td>--><!--<td>{{client.postalCode}}</td>--><!--<td>{{client.city}}</td>--><!--<td>{{client.phoneNumber}}</td>--><!--<td>{{client.faxNumber}}</td>--><td data-translate="{{\'adValoremApp.StatusClient.\' + client.status}}">{{client.status}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="client-detail({id:client.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="client.edit({id:client.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ng-show="client.status == \'ACTIF\'" ui-sref="client.suspend({id:client.id})" class="btn btn-danger btn-sm"><span class="hidden-sm-down" data-translate="adValoremApp.client.suspend.action"></span></button> <button type="submit" ng-show="client.status == \'SUSPENDU\'" ui-sref="client.reactivate({id:client.id})" class="btn btn-default btn-sm"><span class="hidden-sm-down" data-translate="adValoremApp.client.reactivate.action"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/contract/contract-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.contract.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="adValoremApp.contract.delete.question" translate-values="{id: \'{{vm.contract.id}}\'}">Are you sure you want to delete this Contract?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/contract/contract-detail.html','<div><h2><span data-translate="adValoremApp.contract.detail.title">Contract</span> {{vm.contract.contractNumber}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="adValoremApp.contract.company">Company</span></dt><dd><span>{{vm.contract.company}}</span></dd><dt><span data-translate="adValoremApp.contract.contractNumber">Contract Number</span></dt><dd><span>{{vm.contract.contractNumber}}</span></dd><dt><span data-translate="adValoremApp.contract.dueDate">Due Date</span></dt><dd><span>{{vm.contract.dueDate}}</span></dd><dt><span data-translate="adValoremApp.contract.cancellationDate">Cancellation Date</span></dt><dd><span>{{vm.contract.cancellationDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="adValoremApp.contract.suspensionDate">Suspension Date</span></dt><dd><span>{{vm.contract.suspensionDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="adValoremApp.contract.subdivision">Subdivision</span></dt><dd><span data-translate="{{\'adValoremApp.SubdivisionType.\' + vm.contract.subdivision}}">{{vm.contract.subdivision}}</span></dd><dt><span data-translate="adValoremApp.contract.rcRate">Rc Rate</span></dt><dd><span>{{vm.contract.rcRate}} %</span></dd><dt><span data-translate="adValoremApp.contract.vehicleRate">Vehicle Rate</span></dt><dd><span>{{vm.contract.vehicleRate}} %</span></dd><dt><span data-translate="adValoremApp.contract.minObjectValue">Min Object Value</span></dt><dd><span>{{vm.contract.minObjectValue}} \u20AC</span></dd><dt><span data-translate="adValoremApp.contract.maxObjectValue">Max Object Value</span></dt><dd><span>{{vm.contract.maxObjectValue}} \u20AC</span></dd><dt><span data-translate="adValoremApp.contract.minGlobalValue">Min Global Value</span></dt><dd><span>{{vm.contract.minGlobalValue}} \u20AC</span></dd><dt><span data-translate="adValoremApp.contract.maxGlobalValue">Max Global Value</span></dt><dd><span>{{vm.contract.maxGlobalValue}} \u20AC</span></dd><dt><span data-translate="adValoremApp.contract.client">Client</span></dt><dd><a ui-sref="client-detail({id:vm.contract.client.id})">{{vm.contract.client.name}}</a></dd><dt><span data-translate="adValoremApp.contract.status">Status</span></dt><dd><a ui-sref="contract-status-detail({id:vm.contract.status.id})">{{vm.contract.status.name}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="contract-detail.edit({id:vm.contract.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/contract/contract-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myContractLabel" data-translate="adValoremApp.contract.home.createOrEditLabel">Create or edit a Contract</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.contract.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.contract.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.contract.company" for="field_company">Company</label><input type="text" class="form-control" name="company" id="field_company" ng-model="vm.contract.company" required></div><div ng-show="editForm.company.$invalid"><p class="help-block" ng-show="editForm.company.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.contract.contractNumber" for="field_contractNumber">Contract Number</label><input type="text" class="form-control" name="contractNumber" id="field_contractNumber" ng-model="vm.contract.contractNumber" required><div ng-show="editForm.contractNumber.$invalid"><p class="help-block" ng-show="editForm.contractNumber.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.contract.dueDate" for="field_dueDate">Due Date</label><input id="field_dueDate" type="text" class="form-control" name="dueDate" ng-model="vm.contract.dueDate" ui-validate="{isDueDateFormatValid: \'vm.verifyDueDateFormat($value)\', isDueDateDayValid: \'vm.verifyDueDateDay($value)\', isDueDateMonthValid: \'vm.verifyDueDateMonth($value)\'}" required><div ng-show="editForm.dueDate.$invalid"><p class="help-block" ng-show="editForm.dueDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.dueDate.$error.isDueDateFormatValid" data-translate="adValoremApp.contract.validation.dueDateFormatInvalid">The date format must be DD/MM.</p><p class="help-block" ng-show="editForm.dueDate.$error.isDueDateDayValid" data-translate="adValoremApp.contract.validation.invalidDay">The day must be between 01 and 31.</p><p class="help-block" ng-show="editForm.dueDate.$error.isDueDateMonthValid" data-translate="adValoremApp.contract.validation.invalidMonth">The month must be between 01 and 12.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.contract.cancellationDate" for="field_cancellationDate">Cancellation Date</label><div class="input-group"><input id="field_cancellationDate" type="text" class="form-control" name="cancellationDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.contract.cancellationDate" is-open="vm.datePickerOpenStatus.cancellationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'cancellationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.contract.suspensionDate" for="field_suspensionDate">Suspension Date</label><div class="input-group"><input id="field_suspensionDate" type="text" class="form-control" name="suspensionDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.contract.suspensionDate" is-open="vm.datePickerOpenStatus.suspensionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'suspensionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.contract.subdivision" for="field_subdivision">Subdivision</label><select class="form-control" name="subdivision" ng-model="vm.contract.subdivision" id="field_subdivision" required><option value="MENSUEL" data-translate="adValoremApp.SubdivisionType.MENSUEL">MENSUEL</option><option value="TRIMESTRIEL" data-translate="adValoremApp.SubdivisionType.TRIMESTRIEL">TRIMESTRIEL</option></select><div ng-show="editForm.subdivision.$invalid"><p class="help-block" ng-show="editForm.subdivision.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.contract.rcRate" for="field_rcRate">Rc Rate</label><input type="number" class="form-control" name="rcRate" id="field_rcRate" ng-model="vm.contract.rcRate" required><div ng-show="editForm.rcRate.$invalid"><p class="help-block" ng-show="editForm.rcRate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.rcRate.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.contract.vehicleRate" for="field_vehicleRate">Vehicle Rate</label><input type="number" class="form-control" name="vehicleRate" id="field_vehicleRate" ng-model="vm.contract.vehicleRate" required><div ng-show="editForm.vehicleRate.$invalid"><p class="help-block" ng-show="editForm.vehicleRate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.vehicleRate.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.contract.minObjectValue" for="field_minObjectValue">Min Object Value</label><input type="number" class="form-control" name="minObjectValue" id="field_minObjectValue" ng-model="vm.contract.minObjectValue" required><div ng-show="editForm.minObjectValue.$invalid"><p class="help-block" ng-show="editForm.minObjectValue.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.minObjectValue.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.contract.maxObjectValue" for="field_maxObjectValue">Max Object Value</label><input type="number" class="form-control" name="maxObjectValue" id="field_maxObjectValue" ng-model="vm.contract.maxObjectValue" required><div ng-show="editForm.maxObjectValue.$invalid"><p class="help-block" ng-show="editForm.maxObjectValue.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.maxObjectValue.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.contract.minGlobalValue" for="field_minGlobalValue">Min Global Value</label><input type="number" class="form-control" name="minGlobalValue" id="field_minGlobalValue" ng-model="vm.contract.minGlobalValue" required><div ng-show="editForm.minGlobalValue.$invalid"><p class="help-block" ng-show="editForm.minGlobalValue.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.minGlobalValue.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.contract.maxGlobalValue" for="field_maxGlobalValue">Max Global Value</label><input type="number" class="form-control" name="maxGlobalValue" id="field_maxGlobalValue" ng-model="vm.contract.maxGlobalValue" required><div ng-show="editForm.maxGlobalValue.$invalid"><p class="help-block" ng-show="editForm.maxGlobalValue.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.maxGlobalValue.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="adValoremApp.contract.client" for="field_client">Client</label><select class="form-control" id="field_client" name="client" ng-model="vm.contract.client" ng-options="client as client.name for client in vm.clients | orderBy:\'name\' track by client.id" required><option value=""></option></select></div><div ng-show="editForm.client.$invalid"><p class="help-block" ng-show="editForm.client.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="adValoremApp.contract.status" for="field_status">Status</label><select class="form-control" id="field_status" name="status" ng-model="vm.contract.status" ng-options="contractStatus as contractStatus.name for contractStatus in vm.contractstatuses track by contractStatus.id" required><option value=""></option></select></div><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/contract/contracts.html','<div><h2 data-translate="adValoremApp.contract.home.title">Contracts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="contract.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="adValoremApp.contract.home.createLabel">Create new Contract</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'adValoremApp.contract.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="contractNumber"><span data-translate="adValoremApp.contract.contractNumber">Contract Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="company"><span data-translate="adValoremApp.contract.company">Company</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dueDate"><span data-translate="adValoremApp.contract.dueDate">Due Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cancellationDate"><span data-translate="adValoremApp.contract.cancellationDate">Cancellation Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="suspensionDate"><span data-translate="adValoremApp.contract.suspensionDate">Suspension Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="subdivision"><span data-translate="adValoremApp.contract.subdivision">Subdivision</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="rcRate"><span data-translate="adValoremApp.contract.rcRate">Rc Rate</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="vehicleRate"><span data-translate="adValoremApp.contract.vehicleRate">Vehicle Rate</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="minObjectValue"><span data-translate="adValoremApp.contract.minObjectValue">Min Object Value</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="maxObjectValue"><span data-translate="adValoremApp.contract.maxObjectValue">Max Object Value</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="minGlobalValue"><span data-translate="adValoremApp.contract.minGlobalValue">Min Global Value</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="maxGlobalValue"><span data-translate="adValoremApp.contract.maxGlobalValue">Max Global Value</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="client.name"><span data-translate="adValoremApp.contract.client">Client</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status.name"><span data-translate="adValoremApp.contract.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="contract in vm.contracts track by contract.id"><td><a ui-sref="contract-detail({id:contract.id})">{{contract.contractNumber}}</a></td><td>{{contract.company}}</td><td>{{contract.dueDate}}</td><td>{{contract.cancellationDate | date:\'mediumDate\'}}</td><td>{{contract.suspensionDate | date:\'mediumDate\'}}</td><td data-translate="{{\'adValoremApp.SubdivisionType.\' + contract.subdivision}}">{{contract.subdivision}}</td><!--<td>{{contract.rcRate}}</td>--><!--<td>{{contract.vehicleRate}}</td>--><!--<td>{{contract.minObjectValue}}</td>--><!--<td>{{contract.maxObjectValue}}</td>--><!--<td>{{contract.minGlobalValue}}</td>--><!--<td>{{contract.maxGlobalValue}}</td>--><td><a ui-sref="client-detail({id:contract.client.id})">{{contract.client.name}}</a></td><td><a ui-sref="contract-status-detail({id:contract.status.id})">{{contract.status.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="contract-detail({id:contract.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="contract.edit({id:contract.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="contract.delete({id:contract.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/contract-status/contract-status-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.contractStatus.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="adValoremApp.contractStatus.delete.question" translate-values="{id: \'{{vm.contractStatus.id}}\'}">Are you sure you want to delete this Contract Status?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/contract-status/contract-status-detail.html','<div><h2><span data-translate="adValoremApp.contractStatus.detail.title">Contract Status</span> {{vm.contractStatus.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="adValoremApp.contractStatus.name">Name</span></dt><dd><span>{{vm.contractStatus.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="contract-status-detail.edit({id:vm.contractStatus.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/contract-status/contract-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myContractStatusLabel" data-translate="adValoremApp.contractStatus.home.createOrEditLabel">Create or edit a Contract Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.contractStatus.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.contractStatus.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.contractStatus.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.contractStatus.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/contract-status/contract-statuses.html','<div><h2 data-translate="adValoremApp.contractStatus.home.title">Contract Statuses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="contract-status.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="adValoremApp.contractStatus.home.createLabel">Create new Contract Status</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'adValoremApp.contractStatus.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="adValoremApp.contractStatus.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="contractStatus in vm.contractStatuses track by contractStatus.id"><td><a ui-sref="contract-status-detail({id:contractStatus.id})">{{contractStatus.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="contract-status-detail({id:contractStatus.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="contract-status.edit({id:contractStatus.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="contract-status.delete({id:contractStatus.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/country/countries.html','<div><h2 data-translate="adValoremApp.country.home.title">Countries</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="country.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="adValoremApp.country.home.createLabel">Create new Country</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'adValoremApp.country.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="adValoremApp.country.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="codeIso2"><span data-translate="adValoremApp.country.codeIso2">Code Iso 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="codeIso3"><span data-translate="adValoremApp.country.codeIso3">Code Iso 3</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="adValoremApp.country.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="zone.name"><span data-translate="adValoremApp.country.zone">Zone</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="country in vm.countries track by country.id"><td><a ui-sref="country-detail({id:country.id})">{{country.name}}</a></td><td>{{country.codeIso2}}</td><td>{{country.codeIso3}}</td><td data-translate="{{\'adValoremApp.CountryStatus.\' + country.status}}">{{country.status}}</td><td><a ui-sref="zone-detail({id:country.zone.id})">{{country.zone.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="country-detail({id:country.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="country.edit({id:country.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="country.delete({id:country.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/country/country-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.country.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="adValoremApp.country.delete.question" translate-values="{id: \'{{vm.country.id}}\'}">Are you sure you want to delete this Country?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/country/country-detail.html','<div><h2><span data-translate="adValoremApp.country.detail.title">Country</span> {{vm.country.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="adValoremApp.country.name">Name</span></dt><dd><span>{{vm.country.name}}</span></dd><dt><span data-translate="adValoremApp.country.codeIso2">Code Iso 2</span></dt><dd><span>{{vm.country.codeIso2}}</span></dd><dt><span data-translate="adValoremApp.country.codeIso3">Code Iso 3</span></dt><dd><span>{{vm.country.codeIso3}}</span></dd><dt><span data-translate="adValoremApp.country.status">Status</span></dt><dd><span data-translate="{{\'adValoremApp.CountryStatus.\' + vm.country.status}}">{{vm.country.status}}</span></dd><dt><span data-translate="adValoremApp.country.zone">Zone</span></dt><dd><a ui-sref="zone-detail({id:vm.country.zone.id})">{{vm.country.zone.name}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="country-detail.edit({id:vm.country.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/country/country-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCountryLabel" data-translate="adValoremApp.country.home.createOrEditLabel">Create or edit a Country</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.country.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.country.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.country.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.country.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.country.codeIso2" for="field_codeIso2">Code Iso 2</label><input type="text" class="form-control" name="codeIso2" id="field_codeIso2" ng-model="vm.country.codeIso2"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.country.codeIso3" for="field_codeIso3">Code Iso 3</label><input type="text" class="form-control" name="codeIso3" id="field_codeIso3" ng-model="vm.country.codeIso3"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.country.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.country.status" id="field_status" required><option value="COUVERT" data-translate="adValoremApp.CountryStatus.COUVERT">COUVERT</option><option value="EXCLU" data-translate="adValoremApp.CountryStatus.EXCLU">EXCLU</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="adValoremApp.country.zone" for="field_zone">Zone</label><select class="form-control" id="field_zone" name="zone" ng-model="vm.country.zone" ng-options="zone as zone.name for zone in vm.zones track by zone.id" required><option value=""></option></select></div><div ng-show="editForm.zone.$invalid"><p class="help-block" ng-show="editForm.zone.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/dommage-rate/dommage-rate-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.dommageRate.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="adValoremApp.dommageRate.delete.question" translate-values="{id: \'{{vm.dommageRate.id}}\'}">Are you sure you want to delete this Dommage Rate?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/dommage-rate/dommage-rate-detail.html','<div><h2><span data-translate="adValoremApp.dommageRate.detail.title">Dommage Rate</span> {{vm.dommageRate.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="adValoremApp.dommageRate.rate">Rate</span></dt><dd><span>{{vm.dommageRate.rate}}</span></dd><dt><span data-translate="adValoremApp.dommageRate.transportType">Transport Type</span></dt><dd><a ui-sref="transport-type-detail({id:vm.dommageRate.transportType.id})">{{vm.dommageRate.transportType.name}}</a></dd><dt><span data-translate="adValoremApp.dommageRate.zone">Zone</span></dt><dd><a ui-sref="zone-detail({id:vm.dommageRate.zone.id})">{{vm.dommageRate.zone.name}}</a></dd><dt><span data-translate="adValoremApp.dommageRate.client">Client</span></dt><dd><a ui-sref="client-detail({id:vm.dommageRate.client.id})">{{vm.dommageRate.client.name}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="dommage-rate-detail.edit({id:vm.dommageRate.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/dommage-rate/dommage-rate-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDommageRateLabel" data-translate="adValoremApp.dommageRate.home.createOrEditLabel">Create or edit a Dommage Rate</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.dommageRate.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.dommageRate.id" readonly="readonly"></div><div class="form-group"><label data-translate="adValoremApp.dommageRate.client" for="field_client">Client</label><select class="form-control" id="field_client" name="client" ng-model="vm.dommageRate.client" ng-options="client as client.name for client in vm.clients | orderBy:\'name\' track by client.id" required><option value=""></option></select></div><div ng-show="editForm.client.$invalid"><p class="help-block" ng-show="editForm.client.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="adValoremApp.dommageRate.zone" for="field_zone">Zone</label><select class="form-control" id="field_zone" name="zone" ng-model="vm.dommageRate.zone" ng-options="zone as zone.name for zone in vm.zones | orderBy:\'name\' track by zone.id" required><option value=""></option></select></div><div ng-show="editForm.zone.$invalid"><p class="help-block" ng-show="editForm.zone.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="adValoremApp.dommageRate.transportType" for="field_transportType">Transport Type</label><select class="form-control" id="field_transportType" name="transportType" ng-model="vm.dommageRate.transportType" ng-options="transportType as transportType.name for transportType in vm.transporttypes | orderBy:\'name\' track by transportType.id" required><option value=""></option></select></div><div ng-show="editForm.transportType.$invalid"><p class="help-block" ng-show="editForm.transportType.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.dommageRate.rate" for="field_rate">Rate</label><input type="number" class="form-control" name="rate" id="field_rate" ng-model="vm.dommageRate.rate" required><div ng-show="editForm.rate.$invalid"><p class="help-block" ng-show="editForm.rate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.rate.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/dommage-rate/dommage-rates.html','<div><h2 data-translate="adValoremApp.dommageRate.home.title">Dommage Rates</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="dommage-rate.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="adValoremApp.dommageRate.home.createLabel">Create new Dommage Rate</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'adValoremApp.dommageRate.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="rate"><span data-translate="adValoremApp.dommageRate.rate">Rate</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="transportType.name"><span data-translate="adValoremApp.dommageRate.transportType">Transport Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="zone.name"><span data-translate="adValoremApp.dommageRate.zone">Zone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="client.name"><span data-translate="adValoremApp.dommageRate.client">Client</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="dommageRate in vm.dommageRates track by dommageRate.id"><td><a ui-sref="dommage-rate-detail({id:dommageRate.id})">{{dommageRate.id}}</a></td><td>{{dommageRate.rate}}</td><td><a ui-sref="transport-type-detail({id:dommageRate.transportType.id})">{{dommageRate.transportType.name}}</a></td><td><a ui-sref="zone-detail({id:dommageRate.zone.id})">{{dommageRate.zone.name}}</a></td><td><a ui-sref="client-detail({id:dommageRate.client.id})">{{dommageRate.client.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="dommage-rate-detail({id:dommageRate.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="dommage-rate.edit({id:dommageRate.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="dommage-rate.delete({id:dommageRate.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/facility/facilities.html','<div><h2 data-translate="adValoremApp.facility.home.title">Facilities</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="facility.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="adValoremApp.facility.home.createLabel">Create new Facility</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'adValoremApp.facility.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="adValoremApp.facility.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="adValoremApp.facility.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="address1"><span data-translate="adValoremApp.facility.address1">Address 1</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="address2"><span data-translate="adValoremApp.facility.address2">Address 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="address3"><span data-translate="adValoremApp.facility.address3">Address 3</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="postalCode"><span data-translate="adValoremApp.facility.postalCode">Postal Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="city"><span data-translate="adValoremApp.facility.city">City</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phoneNumber"><span data-translate="adValoremApp.facility.phoneNumber">Phone Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="faxNumber"><span data-translate="adValoremApp.facility.faxNumber">Fax Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="client.name"><span data-translate="adValoremApp.facility.client">Client</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="facility in vm.facilities track by facility.id"><td><a ui-sref="facility-detail({id:facility.id})">{{facility.name}}</a></td><td>{{facility.email}}</td><td>{{facility.address1}}</td><td>{{facility.address2}}</td><td>{{facility.address3}}</td><td>{{facility.postalCode}}</td><td>{{facility.city}}</td><td>{{facility.phoneNumber}}</td><td>{{facility.faxNumber}}</td><td><a ui-sref="client-detail({id:facility.client.id})">{{facility.client.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="facility-detail({id:facility.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="facility.edit({id:facility.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="facility.delete({id:facility.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/facility/facility-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.facility.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="adValoremApp.facility.delete.question" translate-values="{id: \'{{vm.facility.id}}\'}">Are you sure you want to delete this Facility?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/facility/facility-detail.html','<div><h2><span data-translate="adValoremApp.facility.detail.title">Facility</span> {{vm.facility.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="adValoremApp.facility.name">Name</span></dt><dd><span>{{vm.facility.name}}</span></dd><dt><span data-translate="adValoremApp.facility.email">Email</span></dt><dd><span>{{vm.facility.email}}</span></dd><dt><span data-translate="adValoremApp.facility.address1">Address 1</span></dt><dd><span>{{vm.facility.address1}}</span></dd><dt><span data-translate="adValoremApp.facility.address2">Address 2</span></dt><dd><span>{{vm.facility.address2}}</span></dd><dt><span data-translate="adValoremApp.facility.address3">Address 3</span></dt><dd><span>{{vm.facility.address3}}</span></dd><dt><span data-translate="adValoremApp.facility.postalCode">Postal Code</span></dt><dd><span>{{vm.facility.postalCode}}</span></dd><dt><span data-translate="adValoremApp.facility.city">City</span></dt><dd><span>{{vm.facility.city}}</span></dd><dt><span data-translate="adValoremApp.facility.phoneNumber">Phone Number</span></dt><dd><span>{{vm.facility.phoneNumber}}</span></dd><dt><span data-translate="adValoremApp.facility.faxNumber">Fax Number</span></dt><dd><span>{{vm.facility.faxNumber}}</span></dd><dt><span data-translate="adValoremApp.facility.client">Client</span></dt><dd><a ui-sref="client-detail({id:vm.facility.client.id})">{{vm.facility.client.name}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="facility-detail.edit({id:vm.facility.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/facility/facility-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFacilityLabel" data-translate="adValoremApp.facility.home.createOrEditLabel">Create or edit a Facility</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.facility.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.facility.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.facility.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.facility.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.facility.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.facility.email" required><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.facility.address1" for="field_address1">Address 1</label><input type="text" class="form-control" name="address1" id="field_address1" ng-model="vm.facility.address1" required><div ng-show="editForm.address1.$invalid"><p class="help-block" ng-show="editForm.address1.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.facility.address2" for="field_address2">Address 2</label><input type="text" class="form-control" name="address2" id="field_address2" ng-model="vm.facility.address2"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.facility.address3" for="field_address3">Address 3</label><input type="text" class="form-control" name="address3" id="field_address3" ng-model="vm.facility.address3"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.facility.postalCode" for="field_postalCode">Postal Code</label><input type="text" class="form-control" name="postalCode" id="field_postalCode" ng-model="vm.facility.postalCode" required><div ng-show="editForm.postalCode.$invalid"><p class="help-block" ng-show="editForm.postalCode.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.facility.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.facility.city" required><div ng-show="editForm.city.$invalid"><p class="help-block" ng-show="editForm.city.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.facility.phoneNumber" for="field_phoneNumber">Phone Number</label><input type="text" class="form-control" name="phoneNumber" id="field_phoneNumber" ng-model="vm.facility.phoneNumber" required><div ng-show="editForm.phoneNumber.$invalid"><p class="help-block" ng-show="editForm.phoneNumber.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.facility.faxNumber" for="field_faxNumber">Fax Number</label><input type="text" class="form-control" name="faxNumber" id="field_faxNumber" ng-model="vm.facility.faxNumber" required><div ng-show="editForm.faxNumber.$invalid"><p class="help-block" ng-show="editForm.faxNumber.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="adValoremApp.facility.client" for="field_client">Client</label><select class="form-control" id="field_client" name="client" ng-model="vm.facility.client" ng-options="client as client.name for client in vm.clients | orderBy:\'name\' track by client.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/guarantee-status/guarantee-status-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.guaranteeStatus.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="adValoremApp.guaranteeStatus.delete.question" translate-values="{id: \'{{vm.guaranteeStatus.id}}\'}">Are you sure you want to delete this Guarantee Status?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/guarantee-status/guarantee-status-detail.html','<div><h2><span data-translate="adValoremApp.guaranteeStatus.detail.title">Guarantee Status</span> {{vm.guaranteeStatus.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="adValoremApp.guaranteeStatus.name">Name</span></dt><dd><span>{{vm.guaranteeStatus.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="guarantee-status-detail.edit({id:vm.guaranteeStatus.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/guarantee-status/guarantee-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGuaranteeStatusLabel" data-translate="adValoremApp.guaranteeStatus.home.createOrEditLabel">Create or edit a Guarantee Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.guaranteeStatus.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.guaranteeStatus.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guaranteeStatus.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.guaranteeStatus.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/guarantee-status/guarantee-statuses.html','<div><h2 data-translate="adValoremApp.guaranteeStatus.home.title">Guarantee Statuses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="guarantee-status.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="adValoremApp.guaranteeStatus.home.createLabel">Create new Guarantee Status</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'adValoremApp.guaranteeStatus.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="adValoremApp.guaranteeStatus.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="guaranteeStatus in vm.guaranteeStatuses track by guaranteeStatus.id"><td><a ui-sref="guarantee-status-detail({id:guaranteeStatus.id})">{{guaranteeStatus.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="guarantee-status-detail({id:guaranteeStatus.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="guarantee-status.edit({id:guaranteeStatus.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="guarantee-status.delete({id:guaranteeStatus.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/guarantee/guarantee-cancel-dialog.html','<form name="cancelForm" ng-submit="vm.confirmCancel(vm.guarantee.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="adValoremApp.guarantee.cancel.title">Confirm cancel operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="adValoremApp.guarantee.cancel.question" translate-values="{id: \'{{vm.guarantee.id}}\'}">Are you sure you want to cancel this Guarantee?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="cancelForm.$invalid" class="btn btn-danger"><span data-translate="adValoremApp.guarantee.cancel.action">cancel</span></button></div></form>');
$templateCache.put('app/entities/guarantee/guarantee-detail.html','<div><h2><span data-translate="adValoremApp.guarantee.detail.title">Guarantee</span> {{vm.guarantee.id}}</h2><hr><jhi-alert-error></jhi-alert-error><h3 data-translate="adValoremApp.guarantee.detail.form_data">Form data</h3><dl class="row jh-entity-details"><dt><span data-translate="adValoremApp.guarantee.client">Client</span></dt><dd><a ui-sref="client-detail({id:vm.guarantee.client.id})">{{vm.guarantee.client.name}}</a></dd><dt><span data-translate="adValoremApp.guarantee.facility">Facility</span></dt><dd><a ui-sref="facility-detail({id:vm.guarantee.facility.id})">{{vm.guarantee.facility.name}}</a></dd><dt><span data-translate="adValoremApp.guarantee.guaranteeType">Guarantee Type</span></dt><dd><a ui-sref="guarantee-type-detail({id:vm.guarantee.guaranteeType.id})">{{vm.guarantee.guaranteeType.name}}</a></dd><dt><span data-translate="adValoremApp.guarantee.guaranteeStatus">Guarantee Status</span></dt><dd><a ui-sref="guarantee-status-detail({id:vm.guarantee.guaranteeStatus.id})">{{vm.guarantee.guaranteeStatus.name}}</a></dd><dt><span data-translate="adValoremApp.guarantee.objectTypeMoved">Object Type Moved</span></dt><dd><a ui-sref="object-type-detail({id:vm.guarantee.objectTypeMoved.id})">{{vm.guarantee.objectTypeMoved.name}}</a></dd><dt><span data-translate="adValoremApp.guarantee.transportType">Transport Type</span></dt><dd><a ui-sref="transport-type-detail({id:vm.guarantee.transportType.id})">{{vm.guarantee.transportType.name}}</a></dd><dt><span data-translate="adValoremApp.guarantee.departureCountry">Departure Country</span></dt><dd><a ui-sref="country-detail({id:vm.guarantee.departureCountry.id})">{{vm.guarantee.departureCountry.name}}</a></dd><dt><span data-translate="adValoremApp.guarantee.arrivalCountry">Arrival Country</span></dt><dd><a ui-sref="country-detail({id:vm.guarantee.arrivalCountry.id})">{{vm.guarantee.arrivalCountry.name}}</a></dd><dt><span data-translate="adValoremApp.guarantee.globalGuarantedValue">Global Guaranted Value</span></dt><dd><span>{{vm.guarantee.globalGuarantedValue}} \u20AC</span></dd><dt><span data-translate="adValoremApp.guarantee.vehiculeValue">Vehicule Value</span></dt><dd><span>{{vm.guarantee.vehiculeValue}} \u20AC</span></dd><dt><span data-translate="adValoremApp.guarantee.empty_nboss">Nboss</span></dt><dd><span>{{vm.guarantee.nboss}}</span></dd><dt><span data-translate="adValoremApp.guarantee.empty_vtoss">Vtoss</span></dt><dd><span>{{vm.guarantee.vtoss}} \u20AC</span></dd><dt><span data-translate="adValoremApp.guarantee.effectiveDate">Effective Date</span></dt><dd><span>{{vm.guarantee.effectiveDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="adValoremApp.guarantee.policyholderName">Policyholder Name</span></dt><dd><span>{{vm.guarantee.policyholderName}}</span></dd><dt><span data-translate="adValoremApp.guarantee.departureSite">Departure Site</span></dt><dd><span>{{vm.guarantee.departureSite}}</span></dd><dt><span data-translate="adValoremApp.guarantee.arrivalSite">Arrival Site</span></dt><dd><span>{{vm.guarantee.arrivalSite}}</span></dd><dt><span data-translate="adValoremApp.guarantee.document">Document</span></dt><dd><a ui-sref="ad-valorem-document-detail({id:vm.guarantee.document.id})">{{vm.guarantee.document.name}}</a></dd></dl><h3 data-translate="adValoremApp.guarantee.detail.bonus">Calculated bonus</h3><dl class="row jh-entity-details"><dt><span data-translate="adValoremApp.guarantee.additionnalBonusObjectValue">Additionnal Bonus Object Value</span></dt><dd><span>{{vm.guarantee.additionnalBonusObjectValue}} \u20AC</span></dd><dt><span data-translate="adValoremApp.guarantee.additionnalBonusGlobalValue">Additionnal Bonus Global Value</span></dt><dd><span>{{vm.guarantee.additionnalBonusGlobalValue}} \u20AC</span></dd><dt><span data-translate="adValoremApp.guarantee.bonusVehiculeValue">Bonus Vehicule Value</span></dt><dd><span>{{vm.guarantee.bonusVehiculeValue}} \u20AC</span></dd><dt><span data-translate="adValoremApp.guarantee.totalBonus">Total Bonus</span></dt><dd><span>{{vm.guarantee.totalBonus}} \u20AC</span></dd></dl><h3 data-translate="adValoremApp.guarantee.detail.rates">Rates</h3><dl class="row jh-entity-details"><dt><span data-translate="adValoremApp.guarantee.tauxRC">Taux RC</span></dt><dd><span>{{vm.guarantee.tauxRC}} %</span></dd><dt><span data-translate="adValoremApp.guarantee.tauxDommage">Taux Dommage</span></dt><dd><span>{{vm.guarantee.tauxDommage}} %</span></dd><dt><span data-translate="adValoremApp.guarantee.tauxValeurVehicule">Taux Valeur Vehicule</span></dt><dd><span>{{vm.guarantee.tauxValeurVehicule}} %</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="guarantee.edit({id:guarantee.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/guarantee/guarantee-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGuaranteeLabel" data-translate="adValoremApp.guarantee.home.createOrEditLabel">Create or edit a Guarantee</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.guarantee.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.guarantee.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.effectiveDate" for="field_effectiveDate">Effective Date</label><div class="input-group"><input id="field_effectiveDate" type="text" class="form-control" name="effectiveDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.guarantee.effectiveDate" is-open="vm.datePickerOpenStatus.effectiveDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'effectiveDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.effectiveDate.$invalid"><p class="help-block" ng-show="editForm.effectiveDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.policyholderName" for="field_policyholderName">Policyholder Name</label><input type="text" class="form-control" name="policyholderName" id="field_policyholderName" ng-model="vm.guarantee.policyholderName" required><div ng-show="editForm.policyholderName.$invalid"><p class="help-block" ng-show="editForm.policyholderName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.departureSite" for="field_departureSite">Departure Site</label><input type="text" class="form-control" name="departureSite" id="field_departureSite" ng-model="vm.guarantee.departureSite" required><div ng-show="editForm.departureSite.$invalid"><p class="help-block" ng-show="editForm.departureSite.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.arrivalSite" for="field_arrivalSite">Arrival Site</label><input type="text" class="form-control" name="arrivalSite" id="field_arrivalSite" ng-model="vm.guarantee.arrivalSite" required><div ng-show="editForm.arrivalSite.$invalid"><p class="help-block" ng-show="editForm.arrivalSite.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.globalGuarantedValue" for="field_globalGuarantedValue">Global Guaranted Value</label><input type="number" class="form-control" name="globalGuarantedValue" id="field_globalGuarantedValue" ng-model="vm.guarantee.globalGuarantedValue" required><div ng-show="editForm.globalGuarantedValue.$invalid"><p class="help-block" ng-show="editForm.globalGuarantedValue.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.globalGuarantedValue.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.vehiculeValue" for="field_vehiculeValue">Vehicule Value</label><input type="number" class="form-control" name="vehiculeValue" id="field_vehiculeValue" ng-model="vm.guarantee.vehiculeValue" required><div ng-show="editForm.vehiculeValue.$invalid"><p class="help-block" ng-show="editForm.vehiculeValue.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.vehiculeValue.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.vtoss" for="field_vtoss">Vtoss</label><input type="number" class="form-control" name="vtoss" id="field_vtoss" ng-model="vm.guarantee.vtoss" required><div ng-show="editForm.vtoss.$invalid"><p class="help-block" ng-show="editForm.vtoss.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.vtoss.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.nboss" for="field_nboss">Nboss</label><input type="number" class="form-control" name="nboss" id="field_nboss" ng-model="vm.guarantee.nboss" required><div ng-show="editForm.nboss.$invalid"><p class="help-block" ng-show="editForm.nboss.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nboss.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.additionnalBonusObjectValue" for="field_additionnalBonusObjectValue">Additionnal Bonus Object Value</label><input type="number" class="form-control" name="additionnalBonusObjectValue" id="field_additionnalBonusObjectValue" ng-model="vm.guarantee.additionnalBonusObjectValue" required><div ng-show="editForm.additionnalBonusObjectValue.$invalid"><p class="help-block" ng-show="editForm.additionnalBonusObjectValue.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.additionnalBonusObjectValue.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.additionnalBonusGlobalValue" for="field_additionnalBonusGlobalValue">Additionnal Bonus Global Value</label><input type="number" class="form-control" name="additionnalBonusGlobalValue" id="field_additionnalBonusGlobalValue" ng-model="vm.guarantee.additionnalBonusGlobalValue" required><div ng-show="editForm.additionnalBonusGlobalValue.$invalid"><p class="help-block" ng-show="editForm.additionnalBonusGlobalValue.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.additionnalBonusGlobalValue.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.bonusVehiculeValue" for="field_bonusVehiculeValue">Bonus Vehicule Value</label><input type="number" class="form-control" name="bonusVehiculeValue" id="field_bonusVehiculeValue" ng-model="vm.guarantee.bonusVehiculeValue" required><div ng-show="editForm.bonusVehiculeValue.$invalid"><p class="help-block" ng-show="editForm.bonusVehiculeValue.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.bonusVehiculeValue.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.totalBonus" for="field_totalBonus">Total Bonus</label><input type="number" class="form-control" name="totalBonus" id="field_totalBonus" ng-model="vm.guarantee.totalBonus" required><div ng-show="editForm.totalBonus.$invalid"><p class="help-block" ng-show="editForm.totalBonus.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.totalBonus.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.tauxRC" for="field_tauxRC">Taux RC</label><input type="number" class="form-control" name="tauxRC" id="field_tauxRC" ng-model="vm.guarantee.tauxRC"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.tauxDommage" for="field_tauxDommage">Taux Dommage</label><input type="number" class="form-control" name="tauxDommage" id="field_tauxDommage" ng-model="vm.guarantee.tauxDommage"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.tauxValeurVehicule" for="field_tauxValeurVehicule">Taux Valeur Vehicule</label><input type="number" class="form-control" name="tauxValeurVehicule" id="field_tauxValeurVehicule" ng-model="vm.guarantee.tauxValeurVehicule"></div><div class="form-group"><label data-translate="adValoremApp.guarantee.guaranteeType" for="field_guaranteeType">Guarantee Type</label><select class="form-control" id="field_guaranteeType" name="guaranteeType" ng-model="vm.guarantee.guaranteeType" ng-options="guaranteeType as guaranteeType.name for guaranteeType in vm.guaranteetypes track by guaranteeType.id" required><option value=""></option></select></div><div ng-show="editForm.guaranteeType.$invalid"><p class="help-block" ng-show="editForm.guaranteeType.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="adValoremApp.guarantee.transportType" for="field_transportType">Transport Type</label><select class="form-control" id="field_transportType" name="transportType" ng-model="vm.guarantee.transportType" ng-options="transportType as transportType.name for transportType in vm.transporttypes track by transportType.id" required><option value=""></option></select></div><div ng-show="editForm.transportType.$invalid"><p class="help-block" ng-show="editForm.transportType.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="adValoremApp.guarantee.objectTypeMoved" for="field_objectTypeMoved">Object Type Moved</label><select class="form-control" id="field_objectTypeMoved" name="objectTypeMoved" ng-model="vm.guarantee.objectTypeMoved" ng-options="objectType as objectType.name for objectType in vm.objecttypes track by objectType.id" required><option value=""></option></select></div><div ng-show="editForm.objectTypeMoved.$invalid"><p class="help-block" ng-show="editForm.objectTypeMoved.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="adValoremApp.guarantee.departureCountry" for="field_departureCountry">Departure Country</label><select class="form-control" id="field_departureCountry" name="departureCountry" ng-model="vm.guarantee.departureCountry" ng-options="country as country.name for country in vm.countries | orderBy:\'name\' track by country.id" required><option value=""></option></select></div><div ng-show="editForm.departureCountry.$invalid"><p class="help-block" ng-show="editForm.departureCountry.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="adValoremApp.guarantee.arrivalCountry" for="field_arrivalCountry">Arrival Country</label><select class="form-control" id="field_arrivalCountry" name="arrivalCountry" ng-model="vm.guarantee.arrivalCountry" ng-options="country as country.name for country in vm.countries | orderBy:\'name\' track by country.id" required><option value=""></option></select></div><div ng-show="editForm.arrivalCountry.$invalid"><p class="help-block" ng-show="editForm.arrivalCountry.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="adValoremApp.guarantee.guaranteeStatus" for="field_guaranteeStatus">Guarantee Status</label><select class="form-control" id="field_guaranteeStatus" name="guaranteeStatus" ng-model="vm.guarantee.guaranteeStatus" ng-options="guaranteeStatus as guaranteeStatus.name for guaranteeStatus in vm.guaranteestatuses track by guaranteeStatus.id" required><option value=""></option></select></div><div ng-show="editForm.guaranteeStatus.$invalid"><p class="help-block" ng-show="editForm.guaranteeStatus.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="adValoremApp.guarantee.client" for="field_client">Client</label><select class="form-control" id="field_client" name="client" ng-model="vm.guarantee.client" ng-options="client as client.name for client in vm.clients | orderBy:\'name\' track by client.id" required><option value=""></option></select></div><div ng-show="editForm.client.$invalid"><p class="help-block" ng-show="editForm.client.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="adValoremApp.guarantee.facility" for="field_facility">Facility</label><select class="form-control" id="field_facility" name="facility" ng-model="vm.guarantee.facility" ng-options="facility as facility.name for facility in vm.facilities | orderBy:\'name\' track by facility.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/guarantee/guarantee-nodialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><h4 class="modal-title" id="myGuaranteeLabel">{{vm.title}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><input type="hidden" name="isDevis" ng-model="vm.guarantee.isDevis"> <input type="hidden" name="userLogin" ng-model="vm.guarantee.userLogin"><div class="form-group" ng-show="vm.guarantee.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.guarantee.id" readonly="readonly"></div><div class="form-group"><label data-translate="adValoremApp.guarantee.guaranteeType" for="field_guaranteeType">Guarantee Type</label><select class="form-control" id="field_guaranteeType" name="guaranteeType" ng-model="vm.guarantee.guaranteeType" ng-options="guaranteeType as guaranteeType.name for guaranteeType in vm.guaranteetypes track by guaranteeType.id" required><option value=""></option></select></div><div ng-show="editForm.guaranteeType.$invalid"><p class="help-block" ng-show="editForm.guaranteeType.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="adValoremApp.guarantee.artObject.label" for="field_artObject">Art Object?</label><span class="tooltip-label-input" tooltip-placement="right" uib-tooltip="{{\'adValoremApp.guarantee.tooltip.artObject\' | translate}}"><img src="content/images/icone-question.png" alt="Tooltip icon"></span><select class="form-control" id="field_artObject" name="artObject" ng-model="vm.guarantee.artObject" ui-validate="{containsArtObject: \'vm.validateArtObject($value)\'}" required><option value=""></option><option data-translate="adValoremApp.guarantee.artObject.optYes" value="true">Yes</option><option data-translate="adValoremApp.guarantee.artObject.optNo" value="false">No</option></select></div><div ng-show="editForm.artObject.$invalid"><p class="help-block" ng-show="editForm.artObject.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.artObject.$error.containsArtObject" data-translate="error.guarantee.contactRequired">You must contact ipierson@accs.fr to fulfill your request.</p></div><div class="form-group"><label data-translate="adValoremApp.guarantee.transportType" for="field_transportType">Transport Type</label><select class="form-control" id="field_transportType" name="transportType" ng-model="vm.guarantee.transportType" ng-options="transportType as transportType.name for transportType in vm.transporttypes track by transportType.id" ng-change="editForm.departureCountry.$validate() ; editForm.arrivalCountry.$validate()" required><option value=""></option></select></div><div ng-show="editForm.transportType.$invalid"><p class="help-block" ng-show="editForm.transportType.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="adValoremApp.guarantee.departureCountry" for="field_departureCountry">Departure Country</label><select class="form-control" id="field_departureCountry" name="departureCountry" ng-model="vm.guarantee.departureCountry" ng-options="country.name+\' (\'+country.zone.name+\')\' for country in vm.countries | orderBy:\'name\' track by country.id" ui-validate="{isAccessibleByRoad: \'vm.validateAccessibleByRoad($value)\', atLeastOneCountryIsInZone1: \'vm.validateAtLeastOneCountryIsInZone1($value, vm.guarantee.arrivalCountry)\'}" ng-change="editForm.arrivalCountry.$validate()" required><option value=""></option></select></div><div ng-show="editForm.departureCountry.$invalid"><p class="help-block" ng-show="editForm.departureCountry.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.departureCountry.$error.isAccessibleByRoad" data-translate="error.guarantee.zoneUnreachable">The zone is unreachable by road.</p><p class="help-block" ng-show="editForm.departureCountry.$error.atLeastOneCountryIsInZone1" data-translate="error.guarantee.missingZone1">At least one country must be in ZONE 1.</p></div><div class="form-group"><label data-translate="adValoremApp.guarantee.arrivalCountry" for="field_arrivalCountry">Arrival Country</label><select class="form-control" id="field_arrivalCountry" name="arrivalCountry" ng-model="vm.guarantee.arrivalCountry" ng-options="country.name+\' (\'+country.zone.name+\')\' for country in vm.countries | orderBy:\'name\' track by country.id" ui-validate="{isAccessibleByRoad: \'vm.validateAccessibleByRoad($value)\', atLeastOneCountryIsInZone1: \'vm.validateAtLeastOneCountryIsInZone1($value, vm.guarantee.departureCountry)\'}" ng-change="editForm.departureCountry.$validate()" required><option value=""></option></select></div><div ng-show="editForm.arrivalCountry.$invalid"><p class="help-block" ng-show="editForm.arrivalCountry.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.arrivalCountry.$error.isAccessibleByRoad" data-translate="error.guarantee.zoneUnreachable">The zone is unreachable by road.</p><p class="help-block" ng-show="editForm.arrivalCountry.$error.atLeastOneCountryIsInZone1" data-translate="error.guarantee.missingZone1">At least one country must be in ZONE 1.</p></div><div class="form-group"><label data-translate="adValoremApp.guarantee.transportedVehicle.label" for="field_transportedVehicle">Transported vehicle?</label><span class="tooltip-label-input" tooltip-placement="right" uib-tooltip="{{\'adValoremApp.guarantee.tooltip.transportedVehicle\' | translate}}"><img src="content/images/icone-question.png" alt="Tooltip icon"></span><select class="form-control" id="field_transportedVehicle" name="transportedVehicle" ng-model="vm.guarantee.transportedVehicle" ng-change="vm.guarantee.vehiculeValue = 0" required><option value=""></option><option data-translate="adValoremApp.guarantee.transportedVehicle.optYes" value="true">Yes</option><option data-translate="adValoremApp.guarantee.transportedVehicle.optNo" value="false">No</option></select></div><div ng-show="editForm.transportedVehicle.$invalid"><p class="help-block" ng-show="editForm.transportedVehicle.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group" ng-show="vm.guarantee.guaranteeType.name==\'DOMMAGE\' && vm.guarantee.transportedVehicle==\'true\'"><label class="control-label" data-translate="adValoremApp.guarantee.vehiculeValue" for="field_vehiculeValue">Vehicule Value</label><input type="number" class="form-control" name="vehiculeValue" id="field_vehiculeValue" ng-model="vm.guarantee.vehiculeValue" min="0" required><div ng-show="editForm.vehiculeValue.$invalid"><p class="help-block" ng-show="editForm.vehiculeValue.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.vehiculeValue.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.globalGuarantedValue" for="field_globalGuarantedValue" ng-show="!(vm.guarantee.guaranteeType.name==\'DOMMAGE\' && vm.guarantee.transportedVehicle==\'true\')">Global Guaranted Value</label><label class="control-label" data-translate="adValoremApp.guarantee.globalGuarantedValueExceptVehicle" for="field_globalGuarantedValue" ng-show="vm.guarantee.guaranteeType.name==\'DOMMAGE\' && vm.guarantee.transportedVehicle==\'true\'">Global Guaranted Value (except vehicle)</label><input type="number" class="form-control" name="globalGuarantedValue" id="field_globalGuarantedValue" ng-model="vm.guarantee.globalGuarantedValue" min="0" ui-validate="{isInfToMaxGlobalValue: \'vm.validateIsInfToMaxGlobalValue($value)\'}" required><div ng-show="editForm.globalGuarantedValue.$invalid"><p class="help-block" ng-show="editForm.globalGuarantedValue.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.globalGuarantedValue.$error.number" data-translate="entity.validation.number">This field should be a number.</p><p class="help-block" ng-show="editForm.globalGuarantedValue.$error.isInfToMaxGlobalValue" data-translate="error.guarantee.contactRequired">You must contact ipierson@accs.fr to fulfill your request.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.nboss" translate-values="{minObjectValue: \'{{vm.contract.minObjectValue}}\'}" for="field_nboss">Nboss</label><input type="number" class="form-control" name="nboss" id="field_nboss" ng-model="vm.guarantee.nboss" min="0" ng-change="editForm.vtoss.$validate() ; vm.updateMinVtossValue()" ui-validate="{nbossMustBeZero: \'vm.validateIfNbossMustBeZero($value)\'}" required><div ng-show="editForm.nboss.$invalid"><p class="help-block" ng-show="editForm.nboss.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nboss.$error.number" data-translate="entity.validation.number">This field should be a number.</p><p class="help-block" ng-show="editForm.nboss.$error.nbossMustBeZero" data-translate="error.guarantee.nbossMustBeZero">Nboss must be superior to zero.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.vtoss" translate-values="{minObjectValue: \'{{vm.contract.minObjectValue}}\'}" for="field_vtoss">Vtoss</label><input type="number" class="form-control" name="vtoss" id="field_vtoss" ng-model="vm.guarantee.vtoss" min="{{vm.minVtossValue}}" ng-change="editForm.nboss.$validate()" ui-validate="{isInfToMaxObjectValue: \'vm.validateIsInfToMaxObjectValue($value)\', vtossMustBeZero: \'vm.validateIfVtossMustBeZero($value)\'}" required><div ng-show="editForm.vtoss.$invalid"><p class="help-block" ng-show="editForm.vtoss.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.vtoss.$error.number" data-translate="entity.validation.number">This field should be a number.</p><p class="help-block" ng-show="editForm.vtoss.$error.isInfToMaxObjectValue" data-translate="error.guarantee.contactRequired">You must contact ipierson@accs.fr to fulfill your request.</p><p class="help-block" ng-show="editForm.vtoss.$error.vtossMustBeZero" data-translate="error.guarantee.vtossMustBeZero">Vtoss must be superior to zero.</p><p class="help-block" ng-show="editForm.vtoss.$error.min" data-translate="error.guarantee.vtossMinValue" translate-values="{minVtossValue: \'{{vm.minVtossValue}}\'}">Vtoss must be at least {{minVtossValue}} \u20AC</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.effectiveDate" for="field_effectiveDate">Effective Date</label><div class="input-group"><input id="field_effectiveDate" type="text" class="form-control" name="effectiveDate" uib-datepicker-popup="{{dateformat}}" datepicker-options="{minDate: vm.today}" ng-model="vm.guarantee.effectiveDate" is-open="vm.datePickerOpenStatus.effectiveDate" ui-validate="{isDateAtLeastToday: \'vm.validateEffectiveDate($value)\'}" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'effectiveDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.effectiveDate.$invalid"><p class="help-block" ng-show="editForm.effectiveDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.effectiveDate.$error.isDateAtLeastToday" data-translate="error.guarantee.invalidDate">The date cannot be before today.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.policyholderName" for="field_policyholderName">Policyholder Name</label><input type="text" class="form-control" name="policyholderName" id="field_policyholderName" ng-model="vm.guarantee.policyholderName" required><div ng-show="editForm.policyholderName.$invalid"><p class="help-block" ng-show="editForm.policyholderName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.departureSite" for="field_departureSite">Departure Site</label><input type="text" class="form-control" name="departureSite" id="field_departureSite" ng-model="vm.guarantee.departureSite" required><div ng-show="editForm.departureSite.$invalid"><p class="help-block" ng-show="editForm.departureSite.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guarantee.arrivalSite" for="field_arrivalSite">Arrival Site</label><input type="text" class="form-control" name="arrivalSite" id="field_arrivalSite" ng-model="vm.guarantee.arrivalSite" required><div ng-show="editForm.arrivalSite.$invalid"><p class="help-block" ng-show="editForm.arrivalSite.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-show="vm.facilities.length > 0"><label data-translate="adValoremApp.guarantee.facility" for="field_facility">Facility</label><select class="form-control" id="field_facility" name="facility" ng-model="vm.guarantee.facility" ng-options="facility as facility.name for facility in vm.facilities track by facility.id" ng-required="vm.facilities.length > 0"><option value=""></option></select></div><div ng-show="editForm.facility.$invalid"><p class="help-block" ng-show="editForm.facility.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>{{ vm.btnSubmitLabel }}</span></button></div><jhi-alert-error></jhi-alert-error><!-- Modale des r\xE9sultats --><script type="text/ng-template" id="resGuaranteeModal.html"><div class="modal-header">\n            <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModalRes()">\n                <span aria-hidden="true">&times;</span>\n            </button>\n            <h3>{{vm.headerModalRes}}</h3>\n            <!--<span ng-click="vm.closeModalRes()">X</span>-->\n        </div>\n        <div class="modal-body">\n            <h4 class="modal-title">{{\'adValoremApp.guarantee.modalRes.title\' | translate}}</h4>\n            <div class="alert-success alert-dismissible" ng-show="!vm.guarantee.isDevis">\n                {{\'adValoremApp.guarantee.modalRes.description\' | translate}}\n                <i class="fa fa-check" aria-hidden="true"></i>\n            </div>\n\n            <hr/>\n\n            <div class="field-readonly">\n                <span>{{\'adValoremApp.guarantee.departureCountry\' | translate}} : </span>\n                {{vm.guarantee.departureCountry.name}}\n            </div>\n            <div class="field-readonly">\n                <span>{{\'adValoremApp.guarantee.arrivalCountry\' | translate}} : </span>\n                {{vm.guarantee.arrivalCountry.name}}\n            </div>\n            <div class="field-readonly">\n                <span>{{\'adValoremApp.guarantee.globalGuarantedValue\' | translate}} : </span>\n                {{vm.guarantee.globalGuarantedValue + vm.guarantee.vehiculeValue}} \u20AC\n            </div>\n            <div class="field-readonly">\n                <span>{{\'adValoremApp.guarantee.empty_vtoss\' | translate}} : </span>\n                {{vm.guarantee.vtoss}} \u20AC\n            </div>\n\n            <hr/>\n\n            <div class="total-bonus">\n                {{\'adValoremApp.guarantee.totalBonus\' | translate}} : {{vm.guarantee.totalBonus}} \u20AC\n            </div>\n        </div></script></form>');
$templateCache.put('app/entities/guarantee/guarantees.html','<div><h2 data-translate="adValoremApp.guarantee.home.title">Guarantees</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'adValoremApp.guarantee.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="client.name"><span data-translate="adValoremApp.guarantee.client">Client</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="facility.name"><span data-translate="adValoremApp.guarantee.facility">Facility</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="effectiveDate"><span data-translate="adValoremApp.guarantee.effectiveDate">Effective Date</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="policyholderName"><span data-translate="adValoremApp.guarantee.policyholderName">Policyholder Name</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="departureSite"><span data-translate="adValoremApp.guarantee.departureSite">Departure Site</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="arrivalSite"><span data-translate="adValoremApp.guarantee.arrivalSite">Arrival Site</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="globalGuarantedValue"><span data-translate="adValoremApp.guarantee.globalGuarantedValue">Global Guaranted Value</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="vehiculeValue"><span data-translate="adValoremApp.guarantee.vehiculeValue">Vehicule Value</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="vtoss"><span data-translate="adValoremApp.guarantee.empty_vtoss">Vtoss</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="nboss"><span data-translate="adValoremApp.guarantee.empty_nboss">Nboss</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="additionnalBonusObjectValue"><span data-translate="adValoremApp.guarantee.additionnalBonusObjectValue">Additionnal Bonus Object Value</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="additionnalBonusGlobalValue"><span data-translate="adValoremApp.guarantee.additionnalBonusGlobalValue">Additionnal Bonus Global Value</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="bonusVehiculeValue"><span data-translate="adValoremApp.guarantee.bonusVehiculeValue">Bonus Vehicule Value</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="totalBonus"><span data-translate="adValoremApp.guarantee.totalBonus">Total Bonus</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="tauxRC"><span data-translate="adValoremApp.guarantee.tauxRC">Taux RC</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="tauxDommage"><span data-translate="adValoremApp.guarantee.tauxDommage">Taux Dommage</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="tauxValeurVehicule"><span data-translate="adValoremApp.guarantee.tauxValeurVehicule">Taux Valeur Vehicule</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="guaranteeType.name"><span data-translate="adValoremApp.guarantee.guaranteeType">Guarantee Type</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th jh-sort-by="transportType.name"><span data-translate="adValoremApp.guarantee.transportType">Transport Type</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="objectTypeMoved.name"><span data-translate="adValoremApp.guarantee.objectTypeMoved">Object Type Moved</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="departureCountry.name"><span data-translate="adValoremApp.guarantee.departureCountry">Departure Country</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="arrivalCountry.name"><span data-translate="adValoremApp.guarantee.arrivalCountry">Arrival Country</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="document.name"><span data-translate="adValoremApp.guarantee.document">Document</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="guaranteeStatus.name"><span data-translate="adValoremApp.guarantee.guaranteeStatus">Guarantee Status</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="guarantee in vm.guarantees track by guarantee.id"><td><a ui-sref="guarantee-detail({id:guarantee.id})">{{guarantee.id}}</a></td><td><a ui-sref="client-detail({id:guarantee.client.id})">{{guarantee.client.name}}</a></td><td><a ui-sref="facility-detail({id:guarantee.facility.id})">{{guarantee.facility.name}}</a></td><td>{{guarantee.effectiveDate | date:\'mediumDate\'}}</td><!--<td>{{guarantee.policyholderName}}</td>--><!--<td>{{guarantee.departureSite}}</td>--><!--<td>{{guarantee.arrivalSite}}</td>--><!--<td>{{guarantee.globalGuarantedValue}}</td>--><!--<td>{{guarantee.vehiculeValue}}</td>--><!--<td>{{guarantee.vtoss}}</td>--><!--<td>{{guarantee.nboss}}</td>--><!--<td>{{guarantee.additionnalBonusObjectValue}}</td>--><!--<td>{{guarantee.additionnalBonusGlobalValue}}</td>--><!--<td>{{guarantee.bonusVehiculeValue}}</td>--><!--<td>{{guarantee.totalBonus}}</td>--><!--<td>{{guarantee.tauxRC}}</td>--><!--<td>{{guarantee.tauxDommage}}</td>--><!--<td>{{guarantee.tauxValeurVehicule}}</td>--><td><a ui-sref="guarantee-type-detail({id:guarantee.guaranteeType.id})">{{guarantee.guaranteeType.name}}</a></td><!--<td>--><!--<a ui-sref="transport-type-detail({id:guarantee.transportType.id})">{{guarantee.transportType.name}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref="object-type-detail({id:guarantee.objectTypeMoved.id})">{{guarantee.objectTypeMoved.name}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref="country-detail({id:guarantee.departureCountry.id})">{{guarantee.departureCountry.name}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref="country-detail({id:guarantee.arrivalCountry.id})">{{guarantee.arrivalCountry.name}}</a>--><!--</td>--><!--<td>--><!--<a ui-sref="ad-valorem-document-detail({id:guarantee.document.id})">{{guarantee.document.name}}</a>--><!--</td>--><td><a ui-sref="guarantee-status-detail({id:guarantee.guaranteeStatus.id})">{{guarantee.guaranteeStatus.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="guarantee-detail({id:guarantee.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="guarantee.edit({id:guarantee.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ng-show="guarantee.guaranteeStatus.name != \'ANNULE\'" ui-sref="guarantee.cancel({id:guarantee.id})" class="btn btn-danger btn-sm"><span class="hidden-sm-down" data-translate="adValoremApp.guarantee.cancel.action"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/guarantee-type/guarantee-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.guaranteeType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="adValoremApp.guaranteeType.delete.question" translate-values="{id: \'{{vm.guaranteeType.id}}\'}">Are you sure you want to delete this Guarantee Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/guarantee-type/guarantee-type-detail.html','<div><h2><span data-translate="adValoremApp.guaranteeType.detail.title">Guarantee Type</span> {{vm.guaranteeType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="adValoremApp.guaranteeType.name">Name</span></dt><dd><span>{{vm.guaranteeType.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="guarantee-type-detail.edit({id:vm.guaranteeType.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/guarantee-type/guarantee-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGuaranteeTypeLabel" data-translate="adValoremApp.guaranteeType.home.createOrEditLabel">Create or edit a Guarantee Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.guaranteeType.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.guaranteeType.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.guaranteeType.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.guaranteeType.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/guarantee-type/guarantee-types.html','<div><h2 data-translate="adValoremApp.guaranteeType.home.title">Guarantee Types</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="guarantee-type.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="adValoremApp.guaranteeType.home.createLabel">Create new Guarantee Type</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'adValoremApp.guaranteeType.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="adValoremApp.guaranteeType.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="guaranteeType in vm.guaranteeTypes track by guaranteeType.id"><td><a ui-sref="guarantee-type-detail({id:guaranteeType.id})">{{guaranteeType.id}}</a></td><td>{{guaranteeType.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="guarantee-type-detail({id:guaranteeType.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="guarantee-type.edit({id:guaranteeType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="guarantee-type.delete({id:guaranteeType.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/object-type/object-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.objectType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="adValoremApp.objectType.delete.question" translate-values="{id: \'{{vm.objectType.id}}\'}">Are you sure you want to delete this Object Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/object-type/object-type-detail.html','<div><h2><span data-translate="adValoremApp.objectType.detail.title">Object Type</span> {{vm.objectType.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="adValoremApp.objectType.name">Name</span></dt><dd><span>{{vm.objectType.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="object-type-detail.edit({id:vm.objectType.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/object-type/object-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myObjectTypeLabel" data-translate="adValoremApp.objectType.home.createOrEditLabel">Create or edit a Object Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.objectType.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.objectType.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.objectType.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.objectType.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/object-type/object-types.html','<div><h2 data-translate="adValoremApp.objectType.home.title">Object Types</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="object-type.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="adValoremApp.objectType.home.createLabel">Create new Object Type</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'adValoremApp.objectType.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="adValoremApp.objectType.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="objectType in vm.objectTypes track by objectType.id"><td><a ui-sref="object-type-detail({id:objectType.id})">{{objectType.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="object-type-detail({id:objectType.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="object-type.edit({id:objectType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="object-type.delete({id:objectType.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/transport-type/transport-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.transportType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="adValoremApp.transportType.delete.question" translate-values="{id: \'{{vm.transportType.id}}\'}">Are you sure you want to delete this Transport Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/transport-type/transport-type-detail.html','<div><h2><span data-translate="adValoremApp.transportType.detail.title">Transport Type</span> {{vm.transportType.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="adValoremApp.transportType.name">Name</span></dt><dd><span>{{vm.transportType.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="transport-type-detail.edit({id:vm.transportType.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/transport-type/transport-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTransportTypeLabel" data-translate="adValoremApp.transportType.home.createOrEditLabel">Create or edit a Transport Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.transportType.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.transportType.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.transportType.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.transportType.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/transport-type/transport-types.html','<div><h2 data-translate="adValoremApp.transportType.home.title">Transport Types</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="transport-type.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="adValoremApp.transportType.home.createLabel">Create new Transport Type</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'adValoremApp.transportType.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="adValoremApp.transportType.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="transportType in vm.transportTypes track by transportType.id"><td><a ui-sref="transport-type-detail({id:transportType.id})">{{transportType.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="transport-type-detail({id:transportType.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="transport-type.edit({id:transportType.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="transport-type.delete({id:transportType.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/zone/zone-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.zone.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="adValoremApp.zone.delete.question" translate-values="{id: \'{{vm.zone.id}}\'}">Are you sure you want to delete this Zone?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/zone/zone-detail.html','<div><h2><span data-translate="adValoremApp.zone.detail.title">Zone</span> {{vm.zone.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="adValoremApp.zone.name">Name</span></dt><dd><span>{{vm.zone.name}}</span></dd><dt><span data-translate="adValoremApp.zone.description">Description</span></dt><dd><span>{{vm.zone.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="zone-detail.edit({id:vm.zone.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/zone/zone-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myZoneLabel" data-translate="adValoremApp.zone.home.createOrEditLabel">Create or edit a Zone</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.zone.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.zone.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.zone.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.zone.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="adValoremApp.zone.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.zone.description"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/zone/zones.html','<div><h2 data-translate="adValoremApp.zone.home.title">Zones</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="zone.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="adValoremApp.zone.home.createLabel">Create new Zone</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'adValoremApp.zone.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="adValoremApp.zone.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="adValoremApp.zone.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="zone in vm.zones track by zone.id"><td><a ui-sref="zone-detail({id:zone.id})">{{zone.name}}</a></td><td>{{zone.description}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="zone-detail({id:zone.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="zone.edit({id:zone.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="zone.delete({id:zone.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-12"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-12"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-advalorem navbar-top" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand ad-valorem logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo-ad-valorem.png" alt="Logo Ad Valorem"></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span data-translate="global.menu.home">Home</span></a></li><li ui-sref-active="active"><a ui-sref="guarantee.new.devis" ng-click="vm.collapseNavbar()" has-authority="ROLE_USER"><span data-translate="adValoremApp.guarantee.home.createDevis">Quotation</span></a></li><li ui-sref-active="active"><a ui-sref="guarantee.new.nodialog" has-authority="ROLE_USER"><span data-translate="adValoremApp.guarantee.home.createLabel">New Guarantee</span></a></li><li><a ui-sref="ad-valorem-library" ng-click="vm.collapseNavbar()" has-authority="ROLE_USER"><span data-translate="global.menu.library">Library</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer" has-authority="ROLE_ADMIN"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="client" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.client">Client</span></a></li><li ui-sref-active="active"><a ui-sref="contract" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.contract">Contract</span></a></li><li ui-sref-active="active"><a ui-sref="facility" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.facility">Facility</span></a></li><li ui-sref-active="active"><a ui-sref="guarantee" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.guarantee">Guarantee</span></a></li><li ui-sref-active="active"><a ui-sref="ad-valorem-document" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.adValoremDocument">Ad Valorem Document</span></a></li><li ui-sref-active="active"><a ui-sref="accs-user" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.accsUser">Accs User</span></a></li><li ui-sref-active="active"><a ui-sref="zone" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.zone">Zone</span></a></li><li ui-sref-active="active"><a ui-sref="country" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.country">Country</span></a></li><li ui-sref-active="active"><a ui-sref="dommage-rate" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.dommageRate">Dommage Rate</span></a></li><li ui-sref-active="active"><a ui-sref="transport-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.transportType">Transport Type</span></a></li><li ui-sref-active="active"><a ui-sref="object-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.objectType">Object Type</span></a></li><li ui-sref-active="active"><a ui-sref="contract-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.contractStatus">Contract Status</span></a></li><li ui-sref-active="active"><a ui-sref="guarantee-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.guaranteeStatus">Guarantee Status</span></a></li><li ui-sref-active="active"><a ui-sref="client.summary" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.clientSummary">Summary Generation</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span data-translate="global.menu.account.sessions">Sessions</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="jhi-login" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span data-translate="global.menu.account.register">Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --><li ng-hide="vm.inProduction"><a href="/h2-console" target="_tab" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-hdd"></span>&nbsp; <span data-translate="global.menu.admin.database">Database</span></a></li><li ui-sref-active="active"><a ui-sref="elasticsearch-reindex" data-toggle="collapse" data-target=".navbar-collapse.in"><span class="glyphicon glyphicon-exclamation-sign"></span>&#xA0; <span translate="global.menu.admin.elasticsearch-reindex">Reindex Elasticsearch</span></a></li></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div><div class="advalorem-banner"><img class="banner-img" src="content/images/photo-header.jpg" alt="Banner image"></div></div></nav>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ui-validate="{isValid: \'vm.checkPassword($value)\', notContainsAccents: \'vm.checkNotContainsAccents($value)\'}" ng-model="vm.resetAccount.password" ng-minlength="8" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 8 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.password.$error.isValid" data-translate="global.messages.validate.newpassword.invalid">Your password is invalid.</p><p class="help-block" ng-show="form.password.$error.notContainsAccents" data-translate="global.messages.validate.newpassword.containsAccentedCharacters">Your password must not contains accented characters</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="8" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 8 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');}]);})();